import { DatatypeHelper, getFunctionByName } from '../utils/datatype-helper';
import HtmlHelper from '../utils/html-helper';
import DegreesModule from '../modules/degrees-module';
import DegreeTypesModule from '../modules/degree-types-module';
import OccupationsModule from '../modules/occupations-module';
import InstitutionsModule from '../modules/institutions-module';
import RecognitionOfficeModule from '../modules/recognition-office-module';
import CertificatesModule from '../modules/certificates-module';
import ExpertisesModule from '../modules/expertises-module';
import BvChapterModule from '../modules/bv-chapter-module';
import NewsModule from '../modules/news-module';
import FaqModule from '../modules/faq-module';
import ReferenceModule from '../modules/reference-module';
import DocumentsModule from "../modules/documents-module";
import HttpHelper from "../utils/http-helper";
import DocumentsCurriculaGfgModule from "../modules/documents-curricula-gfg-module";
import TokenHandler from "../utils/token-handler";
import ResponsibleOfficeModule from "../modules/responsible-office-module";
import QualificationsModule from "../modules/qualifications-module";

const minimizedToken = 'minimized';
const maximizedToken = 'maximized';

function removePositionFromInlineStyles(modal) {
    modal.style.removeProperty('top');
    modal.style.removeProperty('right');
    modal.style.removeProperty('bottom');
    modal.style.removeProperty('left');
}

function setState(modal) {
    const maximizeModalButton = modal.querySelector('#maximizeModalButton');
    const maximizeModalButtonIcon = modal.querySelector('#maximizeModalButton i');
    const minimizeModalButton = modal.querySelector('#minimizeModalButton');
    const minimizeModalButtonIcon = modal.querySelector('#minimizeModalButton i');

    if (modal.classList.contains(maximizedToken)) {
        maximizeModalButtonIcon.classList.remove('p-icon--fullscreen');
        maximizeModalButtonIcon.classList.add('p-icon--canvas', 'mirror-center-x');
        maximizeModalButton.setAttribute('title', 'Zurücksetzen');
    } else {
        maximizeModalButtonIcon.classList.remove('p-icon--canvas', 'mirror-center-x');
        maximizeModalButtonIcon.classList.add('p-icon--fullscreen');
        maximizeModalButton.setAttribute('title', 'Vollbild');
    }

    if (modal.classList.contains(minimizedToken)) {
        minimizeModalButtonIcon.classList.remove('p-icon--minus');
        minimizeModalButtonIcon.classList.add('p-icon--plus');
        minimizeModalButton.setAttribute('title', 'Aufklappen');
    } else {
        minimizeModalButtonIcon.classList.remove('p-icon--plus');
        minimizeModalButtonIcon.classList.add('p-icon--minus');
        minimizeModalButton.setAttribute('title', 'Zuklappen');
    }
}

export function toggleMaximizeModal(event, id) {
    const modal = document.getElementById(id);
    if (modal.classList.contains(maximizedToken)) {
        modal.classList.remove(maximizedToken);
    } else {
        modal.classList.add(maximizedToken);
        modal.classList.remove(minimizedToken);
    }
    removePositionFromInlineStyles(modal);
    setState(modal);
}

export function toggleMinimizeModal(event, id) {
    const modal = document.getElementById(id);
    if (modal.classList.contains(minimizedToken)) {
        modal.classList.remove(minimizedToken);
    } else {
        modal.classList.add(minimizedToken);
        modal.classList.remove(maximizedToken);
    }
    removePositionFromInlineStyles(modal);
    setState(modal);
}

export async function extractExpertiseReferences(references) {
    const expertises = [];
    const expertisesGfg = [];
    if (!!references) {
        if (references?.out.length > 0) {
            const indexToRemove = [];
            await Promise.all(
                references.out.map(async (_ref, idx) => {
                        if (_ref.key === 'Expertise') {
                            indexToRemove.push(idx);
                            const ref = await ExpertisesModule.getId(_ref.object._id);
                            if (!!ref?._id) {
                                if (ref.gfg) {
                                    expertisesGfg.push(ref);
                                } else {
                                    expertises.push(ref);
                                }
                            }
                        }
                    })
            )
            references.out = references.out.filter((reference, index) => !indexToRemove.includes(index));
        }
    }

    return [ expertises, expertisesGfg ]

}

export async function extractDocumentsCurriculumReferences(references, { separateGfg = true, removeGfgReference = false } ) {
    //https://beige-unimaginable-idols.awork.io/tasks/8aaeaa77-b91a-ec11-ae72-0050f26748f5/details
    const referencesGfgCurriculum = [];
    if (!!TokenHandler.isAuthority() && !!references) {

        for (const key of [ 'in', 'out' ]) {
            const indexToRemove = [];
            if (Array.isArray(references[key]) && references[key].length > 0) {
                await Promise.all(references[key].map(async (reference, index) => {
                    if (!!reference.key && reference.key === 'Document') {
                        if (!!reference.object._id) {
                            const doc = await DocumentsModule.getId(reference.object._id);
                            doc.occupationsNameShortList = getReferencedOccupationsNameShortList(doc.reference, removeGfgReference);
                            if (!!separateGfg) {
                                if (doc.gfg &&
                                    (doc?.type?.nameShort === 'Curriculum' || doc?.type?.nameShort === 'Lehrplan')
                                    && doc.occupationsNameShortList !== '<ul class="dash-list"></ul>') {
                                    indexToRemove.push(index);
                                    referencesGfgCurriculum.push(doc);
                                }
                            } else {
                                if (doc?.type?.nameShort === 'Curriculum'
                                    || doc?.type?.nameShort === 'Lehrplan'
                                    && doc.occupationsNameShortList !== '<ul class="dash-list"></ul>') {
                                    indexToRemove.push(index);
                                    referencesGfgCurriculum.push(doc);
                                }
                            }
                        }
                    }
                }));
                references[key] = references[key]?.filter((reference, index) => !indexToRemove.includes(index));
            }
        }
    }

    return referencesGfgCurriculum;

    function getReferencedOccupationsNameShortList(references, removeGfgReference) {
        const occupationsNameShortArray = [];
        let occupationsNameShortList = '<ul class="dash-list">';
        if (!!TokenHandler.isAuthority() && !!references) {
            if (references?.in?.hasOwnProperty('Occupation') && references?.in['Occupation'].length > 0) {
                for (let reference of references?.in['Occupation']) {
                    if(!!removeGfgReference && !reference.gfg) reference = null;
                    reference?.nameShort ?
                        !occupationsNameShortArray.includes(reference?.nameShort) ?
                            occupationsNameShortArray.push(reference?.nameShort) : null: null;
                }
            }
            if (references?.out?.hasOwnProperty('Occupation') && references?.out['Occupation'].length > 0) {
                for (let reference of references?.out['Occupation']) {
                    if(!!removeGfgReference && !reference.gfg) reference = null;
                    reference?.nameShort ?
                        !occupationsNameShortArray.includes(reference?.nameShort) ?
                            occupationsNameShortArray.push(reference?.nameShort) : null: null;
                }
            }
        }
        occupationsNameShortArray.sort();
        occupationsNameShortArray.forEach(element => {
            occupationsNameShortList += (`<li><span>${element}</span></li>`);
        });
        occupationsNameShortList += '</ul>';
        return occupationsNameShortList
    }
}

export function buildExpertiseElement(expertises, expertisesGfg) {
    return `
    <li class="p-accordion__group">
        <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
            <h2 class="p-accordion__title">Mustergutachten <div
                class="p-label--deprecated secret">Vertraulich</div></h2>
        </button>
        <section class="p-accordion__panel" aria-hidden="false">
            <div class="row">
                <div class="col-14">
                    ${ModalDom.renderModalSubTable({
        additionalHeader: null,
        tableHeaders: [ 'Titel des Gutachtens', 'Erstelldatum', 'Land' ],
        array: expertises,
        renderColumns: [ 'nameShort', 'date', 'country.nameShort' ],
        event: {
            entryMethodParameter: '_id',
            entryMethodName: 'openExpertiseModal',
            column: 'nameShort'
        }
    })}
           
                                               ${ModalDom.renderModalSubTable({
        additionalHeader: 'GfG-Mustergutachten',
        tableHeaders: [ 'Titel des Gutachtens', 'Institution', 'Abschlussjahr', 'Auftragsart' ],
        array: expertisesGfg,
        renderColumns: [ 'nameShort', 'institution.nameShort', 'finishYear', 'productType' ],
        event: {
            entryMethodParameter: '_id',
            entryMethodName: 'openExpertiseGfgModal',
            column: 'nameShort'
        }
    })}
        

                </div>
            </div>
        </section>
    </li>`
}

export function extractRenderData(object, data,) {
    if (!object || !data) return ''
    let parsed = ' ';
    const path = data.split('.');

    if (path.length === 3) {
        const parameter1 = path[0];
        const parameter2 = path[1];
        const parameter3 = path[2];

        if (object[parameter1]) {
            if (object[parameter1][parameter2]) {
                if (object[parameter1][parameter2][parameter3]) {
                    parsed = object[parameter1][parameter2][parameter3];
                }
            } else if (Array.isArray(object[parameter1])) {
                object[parameter1].forEach((entry, index) => {
                    if (!!entry) {
                        if (!!entry[parameter2]) {
                            if (!!entry[parameter2][parameter3]) {
                                parsed += entry[parameter2][parameter3];
                                if (index !== (context[parameter1].length - 1)) {
                                    parsed += ', ';
                                }
                            }
                        }
                    }
                });
            }
        }

    }
    if (!!parsed && !parsed.includes("undefined") && parsed !== ' ') {
        object[data] = parsed;
    } else {
        object[data] ? object[data] = object[data] : object[data] = DatatypeHelper.getNestedJsonObjectByString(object, data);
    }
    return object[data]; // && !Array.isArray(object[data])) || (Array.isArray(object[data]) && object[data].length !== 0)
}

export const isLinkRegex = /^http(s)?:\/\//
export const isIsoDateString = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/
export const isEmptyCke = /^<div class="cke-render">(?:<div class="cke-render">)*<\/div>(?:<\/div>)*$/

export function getHtmlForData(renderData, label, event) {
    if (isLinkRegex.test(renderData)) {
        return `<a href="${renderData}" title="Link zu ${label}" target="_blank">${renderData}</a>`;
    }
    if (HtmlHelper.isEmail(renderData)) {
        return `<a class="hiddenMail email" data-email="${renderData}">${HtmlHelper.hideEmail(renderData)}</a>`;
    }
    if (!!isIsoDateString.test(renderData)) {
        return `<span class="max-width-80-ch date">${DatatypeHelper.formattedDate(renderData)}</span>`
    }
    if (!Array.isArray(renderData)) {

    }
    let html = '';
    (Array.isArray(renderData) ? renderData : [ renderData ]).forEach(element => {
        if (!element) return;
        if (!!event) {
            html += `    
                <span class="d-block max-width-80-ch clickable" role="button" id="${event.methodName}" parameter="${event.methodParameter ?? element[event.methodParameterField]}">
                   <i class="p-icon--information"></i> ${element?.nameShort ?? element?.title ?? element}
                </span>
            `
        } else {
            html += `<span class="max-width-80-ch">${element?.nameShort ?? element?.title ?? element}</span>`
        }
    })
    return html
}

export function buildTransposedTable({ modelData, renderConfig }) {
    if (!modelData || !renderConfig?.length) return '';
    let content = ''
    renderConfig.forEach((conf) => {
        if (!conf) return;
        const {
            label,
            field,
            event,
            contentOverride,
            header,
            dataFallback,
            displayAfterContent,
            additionalCssClasses
        } = conf;
        if (header) {
            content += `<tr><th class="ctx-header" colspan="2">${header}</th></tr>`
        }
        if (contentOverride) {
            content += `<tr><td colspan="2" class="content-override ${additionalCssClasses}">${contentOverride}</td></tr>`
            return;
        }
        const renderData = extractRenderData(modelData, field);
        if (
            !(
                (renderData && !Array.isArray(renderData)) && !isEmptyCke.test(renderData) ||
                (Array.isArray(renderData) && renderData.length !== 0) ||
                !!dataFallback
            )
        ) return;

        content += `<tr>
            ${label ? `<th>${label}</th>` : ''}
            <td class="${additionalCssClasses ?? ''}" >${getHtmlForData(renderData, label, event) ?? dataFallback}${displayAfterContent ?? ''}</td>
        </tr>`
    })
    if (!content) return ''
    const table = `<table class="detail-view">${content}</table>`
    return table.replaceAll('tr>', 'TR>')
}

export default class ModalDom {

    constructor() {
        this.modalDrawer = document.querySelector('#modalDrawer');
        this.modalDrawer.removeChild(this.modalDrawer.firstChild); //remove whitespace (#text) node
    }

    addEventListener() {
        window.addEventListener('beforeunload', (e) => {
            if (this.modalDrawer.children.length) {
                e.returnValue = 'Achtung, Ihre geöffneten Datensätze gehen verloren!';
            }
        });
    }

    static preventReOrder = false;

    static addModalHeader(headlines) {

        let dynamicHeadlines = '';

        for (let i = 0; i < headlines.length; i++) {

            if (Array.isArray(headlines[i]?.content)) {
                dynamicHeadlines += `${headlines[i] ? `
                        <div class="row">
                            <div class="col-3">
                                <p><b>${headlines[i].title}:</b></p>
                            </div>
                            <div class="col-9">`
                    : ''}`;
                headlines[i]?.content.forEach((element, index) => {
                    dynamicHeadlines += `${element ?
                        headlines[i].event ? `
                            <div class="col-12 clickable" id="${headlines[i].event.methodName}" parameter="${element[headlines[i].event.methodParameter]}">
                                <i class="p-icon--information">
                                </i>
                               ${element.nameShort}
                            </div>`
                            : `
                            <div class="col-12">
                                <p><b>${element.nameShort}</b></p>
                            </div>`
                        : ''}`;
                });
                dynamicHeadlines += `${headlines[i] ? `
                                </div>
                            </div>`
                    : ''}`;
            } else if (typeof (headlines[i]?.flagged) != 'undefined') {
                if (headlines[i].flagged === 'secret') {
                    dynamicHeadlines += `${headlines[i] ?
                        headlines[i].content ? `
                            <div class="row">
                                 <p><b>${headlines[i].title}:</b>${headlines[i].content ? ` ${headlines[i].content} <div class="p-label--deprecated secret-header">Vertraulich</div>` : ''}</p>
                            </div>`
                            : ''
                        : ''}`;
                } else if (headlines[i].flagged.flag === 'blacklisted') {
                    dynamicHeadlines += `${headlines[i] ?
                        headlines[i].flagged && headlines[i].flagged?.content ? `
                            <div class="row">
                                 <p><b>${headlines[i].title}:</b>${headlines[i].flagged.content ? ` ${headlines[i].flagged.content} <i class="p-icon--warning"></i>` : ''}</p>
                            </div>`
                            : ''
                        : ''}`;
                } else {
                    dynamicHeadlines += `${headlines[i] ?
                        headlines[i].flagged && headlines[i].flagged?.content ? `
                            <div class="row">
                                 <p><b>${headlines[i].title}:</b>${headlines[i].flagged.content ? ` ${headlines[i].flagged.content}` : ''}</p>
                            </div>`
                            : ''
                        : ''}`;
                }
            } else if (headlines.length >= 1 && headlines[i].hasOwnProperty('content')) {
                if (typeof headlines[i].content !== "string") {
                    console.warn(headlines[i].content)
                }
                dynamicHeadlines += `${headlines[i] && headlines[i].content ?
                    headlines[i].event ? `
                            <div class="row">
                            ${headlines[i].domClass ? `<div class="${headlines[i].domClass}"><b>${headlines[i].title}:</b></div>${headlines[i].content ? `
                                    <p><i class="${headlines[i].event.customIcon ? headlines[i].event.customIcon : 'p-icon--information'}"></i>
                                    <span class="clickable" id="${headlines[i].event.methodName}" parameter="${headlines[i].event.methodParameter}">${headlines[i].content}</span></p>
                                    ` : ''}
                            </div>` : `<div><b>${headlines[i].title}:</b>${headlines[i].content ? `
                                    <p><i class="${headlines[i].event.customIcon ? headlines[i].event.customIcon : 'p-icon--information'}"></i>
                                    <span class="clickable" id="${headlines[i].event.methodName}" parameter="${headlines[i].event.methodParameter}">${headlines[i].content}</span></p>
                                    ` : ''}
                                </div>
                            </div>`}
                                `
                        : `
                        <div class="row">
<!--                        https://beige-unimaginable-idols.awork.io/tasks/5858e957-a759-ec11-94f6-501ac527997d/details-->
                            ${headlines[i].domClass ? 
                            `<div class="noWhiteSpace ${headlines[i].domClass}">${headlines[i].title}:</div><p>${headlines[i].content ? `${headlines[i].content}` : ''}</p>` : 
                            `<p><b>${headlines[i].title}:</b>${headlines[i].content ? ` ${headlines[i].content}` : ''}</p>`}
                             
                        </div>`
                    : ''}`;
            } else {
                dynamicHeadlines += `${headlines[i] ?
                    headlines[i].title ? `
                         <h1><b>${headlines[i].title}:</b></h1>`
                        : ''
                    : ''}`;
            }
        }

        return `
                <header class="p-modal__header">
                <div class="draggable modal-header-buttons window-bar">
<!--                            <span class="draggable p-button&#45;&#45;base has-icon" title="Hier klicken und bewegen"><i class="p-icon&#45;&#45;drag"></i></span>-->
                            <button title="Drucken" id="printModalButton" class="u-no-print p-button--base has-icon" aria-label="Minimize active modal" aria-controls="modal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24.993 24.993"><defs><style>.a{fill:none;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px;}</style></defs><g transform="translate(-2 -2)"><path class="a" d="M9,11.048V3H22.8v8.048" transform="translate(-1.401 0)"/><path class="a" d="M7.6,23.847H5.3a2.3,2.3,0,0,1-2.3-2.3V15.8a2.3,2.3,0,0,1,2.3-2.3H23.694a2.3,2.3,0,0,1,2.3,2.3v5.748a2.3,2.3,0,0,1-2.3,2.3h-2.3" transform="translate(0 -2.452)"/><path class="a" d="M9,21H22.8v9.2H9Z" transform="translate(-1.401 -4.204)"/></g></svg>
                                <div class="d-none">          
                                    The MIT License (MIT) Copyright (c) 2019-2020 The Bootstrap Authors Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </div>
                            <button title="Zuklappen" id="minimizeModalButton" class="u-no-print p-button--base has-icon aria-label="Minimize active modal" aria-controls="modal">
                                <i class="p-icon--minus is-light"></i></button>                            
                            <button title="Vollbild" id="maximizeModalButton" class="u-no-print p-button--base has-icon aria-label="Maximize active modal" aria-controls="modal">
                                <i class="p-icon--fullscreen is-light"></i></button>
                            <button title="Schließen" id="removeModalButton" class="u-no-print p-button--base has-icon" aria-label="Close active modal" aria-controls="modal">
                                 <i class="p-icon--close is-light"></i></button>
                            </button>
                        </div>
                    <div class="info-bar">
                            ${dynamicHeadlines}
                    </div>
                </header>
        `;
    }

    static renderModalSubTable({ additionalHeader, tableHeaders, array, renderColumns, event }) {
        if (!array?.length || !renderColumns.length || !tableHeaders.length) return '';
        console.assert(renderColumns.length === tableHeaders.length)

        let html = '<table class="sub-table">';
        if (additionalHeader) {
            html += `<tr><th class="ctx-header" colspan="${tableHeaders.length}">${additionalHeader}</th></tr>`;
        }


        html += `<tr class="col-header">${tableHeaders.map((headerTitle, idx) => {
            if (event?.headerPos === idx) {
                return `<th><span class="clickable" id="${event.headerMethodName}" parameter="${event.headerMethodParameter}">${headerTitle}</span></th>`
            }
            return `<th>${headerTitle}</th>`
        }).join('')}</tr>`
        array.forEach((object, arrayIndex) => {
            if (!object || Object.keys(object).length <= 0) return;
            renderColumns.forEach(column => {
                // todo WHAT THE F*CK?!
                object[column] ? object[column] = object[column] : object[column] = DatatypeHelper.getNestedJsonObjectByString(object, column);

                if (!!Date.parse(object[column]) && typeof object[column] == 'string' && object[column].includes('T')) {
                    let toDate = object[column].split('T')[0];
                    if (!!Date.parse(toDate)) {
                        object[column] = !!Date.parse(object[column]) ? DatatypeHelper.formattedDate(object[column]) : null;
                    }
                }

            });

            html += `<tr>${renderColumns.map(entry =>
                renderEntry(object, entry, arrayIndex)
            ).join('')}</tr>`;

            return html;
        })


        function renderEntry(object, entry, index) {
            let eventParameter = '';
            if (event && event.entryMethodParameter && entry === event.column) {
                if (Array.isArray(event.entryMethodParameter)) {
                    event.entryMethodParameter.forEach((parameter, index) => {
                        let parsedObject = object[event.entryMethodParameter[index]] ? object[event.entryMethodParameter[index]] = object[event.entryMethodParameter[index]] : object[event.entryMethodParameter[index]] = DatatypeHelper.getNestedJsonObjectByString(object, parameter);
                        if (!parsedObject) {
                            eventParameter += event.entryMethodParameter[index];
                        } else {
                            eventParameter += parsedObject;
                        }
                        if (index < event.entryMethodParameter.length - 1) {
                            eventParameter += ',';
                        }
                    });
                } else {
                    eventParameter = object[event.entryMethodParameter] ? object[event.entryMethodParameter] = object[event.entryMethodParameter] : object[event.entryMethodParameter] = DatatypeHelper.getNestedJsonObjectByString(object, event.entryMethodParameter);
                }
            }
            let methodName = '';
            if (event) {
                if (Array.isArray(event.entryMethodName)) {
                    methodName = event.entryMethodName[index];
                } else {
                    methodName = event.entryMethodName;
                }
            }
            let isHiddenMail = false;
            let hiddenMailClass = '';
            let hiddenMailAttribute = '';
            if (HtmlHelper.isEmail(object[entry])) {
                object[entry] = HtmlHelper.hideEmail(object[entry]);
                hiddenMailClass = 'hiddenMail email';
                hiddenMailAttribute = `data-email="${object[entry]}"`;
                isHiddenMail = true;
            }
            return object[entry] ? `
                <td>
                        ${event && event.entryMethodParameter && entry === event.column ? `
                            <span class="clickable" id="${methodName}" parameter="${eventParameter}">
                                <i class="p-icon--information">
                                </i>    
                                ${object[entry]}
                            </span>
                        ` :
                    isHiddenMail ? `<a class="${hiddenMailClass}" ${hiddenMailAttribute}>${object[entry]}</a>` :
                        `<span>${object[entry]}</span>`}                                
                   
                </td>
            `
                : '<td>&nbsp;</td>';
        }

        html += '</table>';
        return html.replaceAll('tr>', 'TR>');
    }

    static renderCertificateModalSubTable(casegroups) {

        let html = '';

        if (Array.isArray(casegroups) && casegroups.length > 0) {
            casegroups.forEach((casegroup) => {
                html += '<table class="sub-table certificate-casegroup-table certificateCasegroupFix">';

                if (!!casegroup.nameShort) {
                    html += `
                        <tr class="col-header casegroup-nameShort">
                            <th>${casegroup.nameShort}</th>
                            <th>Weitere Bedingungen</th>
                        </tr>
                     `;

                    //https://beige-unimaginable-idols.awork.io/tasks/25f83d6b-fb42-ec11-981f-501ac527b592/details
                    const commentArray = casegroup.involvedCertificates?.filter?.(involvedCertificate => involvedCertificate.comment)
                    //https://beige-unimaginable-idols.awork.io/tasks/529febce-2d8b-ec11-a506-38563d687406/details
                    let template = '';
                    casegroup.involvedCertificates?.forEach?.((involvedCertificate, index) => {
                        if (!!involvedCertificate.certificate?.nameShort) {
                            template += `
                                    ${index !== 0 ? `<small class="d-block d-non-empty certificate-relation">${involvedCertificate?.relation !== 'Serie' ? involvedCertificate?.relation : ''}</small>` : ''}
                                    <span>${involvedCertificate.certificate?.nameShort}</span>
                            `
                        }
                    });
                    casegroup.involvedCertificates?.forEach?.((involvedCertificate, index) => {
                        if (!!involvedCertificate.certificate?.nameShort || !!involvedCertificate.comment) {
                            html +=`<tr class="casegroup-involvedCertificates">`
                            html += `${template !== '' ? `
                                    <td>
                                        ${template}
                                    </td>` : ''}
                            `
                            template = ''
                            //https://beige-unimaginable-idols.awork.io/tasks/4c26f698-f742-ec11-981f-501ac527b592/details
                            if (index === 0) {
                                html += `<td rowspan="${casegroup.involvedCertificates.length}">`
                                commentArray.forEach(el => {
                                    html += el.comment ? el.comment + '<br>' : '&nbsp;'
                                })
                                html += '</td>'
                            }
                            html += '</tr>'
                        }
                    });
                    if (Array.isArray(casegroup.rules) && casegroup.rules.length > 0) {
                        casegroup.rules?.forEach?.((rule) => {
                            html += `     
                            <tr class="casegroup-rule">
                                    <td>${returnRuleLeftSide(rule) ?? '&nbsp;'}</td>
                                    <td>${returnRuleRightSide(rule) ?? '&nbsp;'}</td>
                                </tr>   
                         `;
                        });
                    }
                }
                html += '</table>';
            });

        }

        function returnRuleLeftSide(object) {
            let ruleLeftSide = '';
            if (!!object) {
                if (!!object.ruletype && !!object.ruletype?.nameShort) {
                    ruleLeftSide += `<strong style="font-weight: 700">${object.ruletype.nameShort}</strong>`;
                }
                if (!!object.binding && (!!object.ruletype)) {
                    if (object.ruletype.abbreviation === 'FZG' || object.ruletype.abbreviation === 'FFSP') {
                        if (!!object.ruletype.comment && object.ruletype.comment !== '') {
                            ruleLeftSide += `<br>${object.ruletype.comment}`;
                        }
                    }
                }
                if (!!object.comment) {
                    ruleLeftSide += `<br>${object.comment.replaceAll('tr>', 'TR>')}`;
                }
                if (!!object.bindingComment) {
                    ruleLeftSide += `<br>${object.bindingComment}`;
                }
                if (!!object.studies && !!object.studiesLength) {
                    ruleLeftSide += `<br>bei Nachweis von ${object.studiesLength} erfolgreichen Studienjahr(en)`;
                }
                if (!!object.institutiontype) {
                    ruleLeftSide += `<br>${object.institutiontype}`;
                }
            }
            return ruleLeftSide;
        }

        function returnRuleRightSide(object) {
            let ruleRightSide = '';
            if (!!object) {
                if (!!object.ruletext) {
                    ruleRightSide += `${object.ruletext}`;
                }
                if (Array.isArray(object.bvchapters) && object.bvchapters.length > 0) {
                    object.bvchapters.forEach(bvchapter => {
                        if (!!bvchapter._id && !!bvchapter.title) {
                            ruleRightSide += `                            
                            <li class="col-6 clickable" id="openBvChapterModal" parameter="${bvchapter._id}/override">
                                <i class="p-icon--information">
                                </i>
                                ${bvchapter.title} public
                            </li>
                            `;
                        }
                    });
                }
            }
            return ruleRightSide;
        }


        return html.replaceAll('tr>', 'TR>');
    }

    /**
     * @deprecated
     */
    static renderModalTableEntry(object, label, data, event) {


        let returnData = '';
        let parsed = ' ';
        const splited = data.split('.');

        if (splited.length === 3) {
            const parameter1 = splited[0];
            const parameter2 = splited[1];
            const parameter3 = splited[2];

            if (object[parameter1]) {
                if (object[parameter1][parameter2]) {
                    if (object[parameter1][parameter2][parameter3]) {
                        parsed = object[parameter1][parameter2][parameter3];
                    }
                } else if (Array.isArray(object[parameter1])) {
                    object[parameter1].forEach((entry, index) => {
                        if (!!entry) {
                            if (!!entry[parameter2]) {
                                if (!!entry[parameter2][parameter3]) {
                                    parsed += entry[parameter2][parameter3];
                                    if (index !== (context[parameter1].length - 1)) {
                                        parsed += ', ';
                                    }
                                }
                            }
                        }
                    });
                }
            }

        }
        if (!!parsed && !parsed.includes("undefined") && parsed !== ' ') {
            object[data] = parsed;
        } else {
            object[data] ? object[data] = object[data] : object[data] = DatatypeHelper.getNestedJsonObjectByString(object, data);
        }


        const hasDataToRender = (object[data] && !Array.isArray(object[data])) || (Array.isArray(object[data]) && object[data].length !== 0)
        if (hasDataToRender) {
            let isHiddenMail = false;
            let hiddenMailClass = '';
            let hiddenMailAttribute = '';
            if (HtmlHelper.isEmail(object[data])) {
                object[data] = HtmlHelper.hideEmail(object[data]);
                hiddenMailClass = 'hiddenMail email';
                hiddenMailAttribute = `data-email="${object[data]}"`;
                isHiddenMail = true;
            }
            if (HtmlHelper.isLink(object[data])) {
                object[data] = `<a href="${object[data]}" title="Link zu ${data}" target="_blank">${object[data]}</a>`;
            }
            returnData = data ? `
                    <div class="row detail-table">
                        <p class="col-7">${label}</p>
                ` : '';
            if (Array.isArray(object[data])) {

                returnData += `
                    <div class="col-5">
                `;
                object[data].forEach(element => {

                    returnData += `
                        ${data ? `
                            ${event ?
                        `
                                    <p class="col-5 clickable" id="${event.methodName}" parameter="${element[event.methodParameter]}">
                                       <i class="p-icon--information">
                                        </i>
                                        ${element['nameShort']}
                                    </p>
                                ` : `<p class="col-5">${element['nameShort']}</p>`}
                        ` : ''}
                     `;
                });
                returnData += `
                    </div>
                `;
            } else {
                returnData += `<div class="col-5">
                    ${object[data] ? `
                        ${event ?
                    `    
                                    <p class="clickable" id="${event.methodName}" parameter="${event.methodParameter}">
                                       <i class="p-icon--information">
                                        </i>
                                        ${object[data]}
                                    </p>
                                ` :
                    isHiddenMail ? `<a class="${hiddenMailClass}" ${hiddenMailAttribute}>${object[data]}</a>` :
                        `<p>${object[data]}</p>`}
                        ` : ''}
                    </div>`;

            }
            returnData += `
                ${object[data] ? `
                    </div>
                ` : ''}
            `;
        }
        // ${!!bvChapter.content ? `<div>${bvChapter.content.replaceAll('tr>', 'TR>')}</div>` : ''}
        return returnData.replaceAll('tr>', 'TR>');
    }

    static renderReferenceSubTable(reference) {

        let referencesNames = [];
        let references = [];
        const ids = [];
        if (reference?.hasOwnProperty('in')) {
            if (Array.isArray(reference.in) && reference.in.length > 0) {
                reference.in.forEach(reference => {
                    if (!ids.includes(reference?.object?._id)) {
                        ids.push(reference.object._id)
                        if (reference.key === 'Document' || reference.key === 'BvChapter') {
                            reference.object.nameShort = reference.object.title;
                        }
                        // if (reference.object?.gfg === true) {
                        //     reference.displayName += '<i id="secret" class="p-icon--lock-unlock secret" title="vertraulich"></i>';
                        // }

                        reference.displayName = ReferenceModule.keyToLanguage(reference.key)
                        references.push(reference);
                        referencesNames.push(ReferenceModule.keyToModalMethod(reference.key));
                    }
                });
            }
        }
        if (reference?.hasOwnProperty('out')) {
            if (Array.isArray(reference.out) && reference.out.length > 0) {
                reference.out.forEach(reference => {
                    if (!ids.includes(reference?.object?._id)) {
                        ids.push(reference.object._id)
                        if (reference.key === 'Document' || reference.key === 'BvChapter') {
                            reference.object.nameShort = reference.object.title;
                        }
                        // if (reference.object?.gfg === true) {
                        //     reference.displayName += '<i id="secret" class="p-icon--lock-unlock secret" title="vertraulich"></i>';
                        // }
                        reference.displayName = ReferenceModule.keyToLanguage(reference.key)
                        references.push(reference);
                        referencesNames.push(ReferenceModule.keyToModalMethod(reference.key));
                    }
                });
            }
        }
        const reorderedArray = ReferenceModule.reorderReferenceArray(references, referencesNames);
        references = reorderedArray[0];
        referencesNames = reorderedArray[1];
        if (references.length === 0 && referencesNames.length === 0) {
            return '';
        }
        return ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Verweis auf', 'Bezeichnung', 'Land' ],
            array: references,
            renderColumns: [ 'displayName', 'object.nameShort', 'object.country.nameShort', ],
            event: {
                entryMethodParameter: 'object._id',
                entryMethodName: referencesNames,
                column: 'object.nameShort'
            }
        });
    }


    static async openQualificationsModal(qualification) {
        if (!this) {
            qualification = await QualificationsModule.getId(qualification);
        }
        await ModalDom.openDegreeModal(qualification);
    }

    static async openDegreeModal(degree) {
        if (!this) {
            degree = await DegreesModule.getId(degree);
        }
        const references = await ReferenceModule.getReferenceObject(degree.reference);
        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);

        const detailViewTemplate = `
        <div class="p-modal resizable openDegreeModal" aria-hidden="false" aria-controls="false" id="${degree._id}">
            ${ModalDom.addModalHeader([ { title: 'Land', content: degree.country?.nameShort },
            { title: 'Abschluss', content: degree.nameShort } ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Beschreibung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
      ${buildTransposedTable({
            modelData: degree,
            renderConfig: [
                {
                    label: 'Abschluss',
                    field: 'nameShort'
                }, {
                    label: 'Abschluss (deutsche Übersetzung)',
                    field: 'nameGerman'
                }, {
                    label: 'Weibliche Form der Abschlussbezeichnung',
                    field: 'nameFemale'
                }, {
                    label: 'Weibliche Form der Abschlussbezeichnung auf Deutsch',
                    field: 'nameFemaleGerman'
                }, {
                    label: 'Dauer des Studiums zur Erlangung des Abschlusses (Jahre)',
                    field: 'studiesLength'
                }, {
                    label: 'Abkürzung',
                    field: 'degreeShort'
                }, {
                    label: 'Abschlusstyp',
                    field: 'degreeType.nameShort',
                    event: {
                        methodName: 'openDegreeTypeInformationModal',
                        methodParameter: degree.degreeType?._id
                    }
                }, {
                    label: 'Studienrichtung',
                    field: 'fieldOfStudy.nameShort',
                }, {
                    label: 'Studienrichtung (deutsche Übersetzung)',
                    field: 'fieldOfStudy.nameGerman',
                }, {
                    label: 'Abschlussklasse',
                    field: 'degreeType.degreeclass.nameShort',
                    event: {
                        methodName: 'openDegreeClassInformationModal',
                        methodParameter: degree.degreeType?.degreeclass?._id
                    }
                }, {
                    label: 'Beschreibung der Ausbildung',
                    field: 'description',
                }, {
                    label: 'Vorbildung',
                    field: 'requirement',
                }, {
                    label: 'Kommentar',
                    field: 'comment',
                },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'Andere Bezeichnung für diesen Abschluss', 'Sprache', 'Deutsche Übersetzung', 'Kommentar' ],
                        array: degree.alternativeNames,
                        renderColumns: [ 'nameShort', 'language.nameShort', 'nameGerman', 'comment' ],
                        event: null
                    })
                }
            ]
        })}
      
      

                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Studiendetails</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${buildTransposedTable({
            modelData: degree,
            renderConfig: [
                (degree.theoryMin ||
                    degree.theoryMax ||
                    (degree.theoryDescription && !isEmptyCke.test(degree.theoryDescription)) ||
                    (degree.theoryComment && !isEmptyCke.test(degree.theoryComment))
                ) ? { header: 'Theorie' } : null,
                { label: 'Dauer des Theorieteils (min)', field: 'theoryMin', displayAfterContent: ' Jahr(e)' },
                { label: 'Dauer des Theorieteils (max)', field: 'theoryMax', displayAfterContent: ' Jahr(e)' },
                { label: 'Beschreibung des Theorieteils', field: 'theoryDescription' },
                { label: 'Anmerkungen zur Qualität', field: 'theoryComment' },
                degree.practiceMin ||
                degree.practiceMax ||
                (degree.practiceDescription && !isEmptyCke.test(degree.practiceDescription)) ||
                (degree.practiceDescription && !isEmptyCke.test(degree.practiceComment)) ? { header: 'Praxis' } : null,
                { label: 'Dauer des Praxisteils (min)', field: 'practiceMin', displayAfterContent: ' Jahr(e)' },
                { label: 'Dauer des Praxisteils (max)', field: 'practiceMax', displayAfterContent: ' Jahr(e)' },
                { label: 'Beschreibung des Praxisteils', field: 'practiceDescription' },
                { label: 'Anmerkungen zur Qualität', field: 'practiceComment' },
            ]
        })}
                                        
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Bewertung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                                ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Äquivalenzklasse', 'Entsprechender dt. Abschlusstyp', 'Kommentar' ],
            array: degree.equivalences,
            renderColumns: [ 'equivalenceClass', 'degreeType.nameShort', 'comment' ],
            event: {
                entryMethodParameter: 'degreeType._id',
                entryMethodName: 'openEquivalenceGermanDegreeTypeInformationModal',
                column: 'degreeType.nameShort',
                headerMethodParameter: '',
                headerMethodName: 'openEquivalencesInformationModal',
                headerPos: 0
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Behördeninformationen zur Bewertung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${buildTransposedTable({
            modelData: degree,
            renderConfig: [
                { label: 'Hinweise zur Gradführung', field: 'degreeConductInfo' },
                { label: 'Hinweise zur Umwandlung', field: 'degreeConductTransformation' },
                { label: 'Hinweise zum Promotionszugang', field: 'accessInformation' },
                { label: 'Zugang zum Masterstudium', field: 'masterInformation' },
                {
                    label: 'Hinweise zum Hochschulzugang bzw. zur Anrechnung von Studienleistungen',
                    field: 'performanceInformation'
                },
                { label: 'Anerkennung im beruflichen Bereich', field: 'recognition' },
                { label: 'Sonstiges', field: 'miscInformation' },
            ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                             ${buildExpertiseElement(expertises, expertisesGfg)}
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Verleihende Institutionen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Name der Institution', 'Ort', 'Institutionstyp', 'Status', 'Land' ],
            array: degree.institutions,
            renderColumns: [ 'nameShort', 'location.originName', 'institutionType.nameShort', 'institutionType.status.nameShort', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openInstitutionModal',
                column: 'nameShort'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderReferenceSubTable(references)}
                                        
                                        </div>
                                    </div>
                                </section>
                            </li>  

                      </ul>
                    </div>
                </div>
            </div>
        </div>
    `;
        ModalDom.finishModalElement(detailViewTemplate, degree._id);
    }

    static async openCertificateWithoutChildrenModal(certificate, parentCertificateNameShort) {

        if (!(certificate instanceof Object) || !!certificate.isChildCertificate) {
            if (!!certificate._id) {
                certificate = await CertificatesModule.getId(certificate._id);
            } else {
                certificate = await CertificatesModule.getId(certificate);
            }
            if (parentCertificateNameShort) {
                certificate.parentCertificateNameShort = parentCertificateNameShort;
            } else if (!!certificate.parent?.nameShort) {
                certificate.parentCertificateNameShort = certificate.parent.nameShort;
            }
        }
        const hasCertificatePrototypesFiles = certificate.certificateprototypes?.some((prototype) => !!prototype.files?.length);
        const references = ReferenceModule.getReferenceObject(certificate.reference);
        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);
        const hasParent = !!certificate.parent?.nameShort;

        const detailViewTemplate = `
        <div custom="CertificateWithoutChildren" class="p-modal resizable openCertificateWithoutChildrenModal" aria-hidden="false" aria-controls="false" id="${certificate._id}CertificateWithoutChildren">
            ${ModalDom.addModalHeader(hasParent ? [ {
            title: 'Land',
            content: certificate.country?.nameShort,
            domClass: 'model-header-list'
        },
            {
                title: 'Schulabschluss',
                content: !!certificate.parent?.nameShort ? certificate.parent.nameShort : '',
                domClass: 'model-header-list'
            },
            { title: 'Übersetzung', content: certificate.parent?.nameGerman, domClass: 'model-header-list' },
            { title: 'Kommentar', content: certificate.parent?.comment, domClass: 'model-header-list' },
            {
                title: 'Spezifizierung',
                content: certificate.nameShort,
                domClass: 'model-header-list'
            },
            { title: 'Übersetzung', content: certificate.nameGerman, domClass: 'model-header-list' },
            {
                title: 'Kommentar',
                content: !!certificate.comment ? `<p>${certificate.comment.replaceAll('tr>', 'TR>')}</p>` : '',
                domClass: 'model-header-list'
            }
        ] : [ {
            title: 'Land',
            content: certificate.country?.nameShort,
            domClass: 'model-header-list'
        },
            {
                title: 'Schulabschluss',
                content: certificate.nameShort,
                domClass: 'model-header-list'
            },
            { title: 'Übersetzung', content: certificate.nameGerman, domClass: 'model-header-list' },
            {
                title: 'Kommentar',
                content: !!certificate.comment ? `<p>${certificate.comment.replaceAll('tr>', 'TR>')}</p>` : '',
                domClass: 'model-header-list'
            }
        ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">
                                        <div class="p-label--deprecated secret">Vertraulich</div>
                                        Kommentar</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
            
                                                ${!!certificate.adminComment ? `<div>${certificate.adminComment.replaceAll('tr>', 'TR>')}</div>` : ''}
                  
                                            </div>
                                        </div>
                                    </section>
                                </li>
                                                            
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">
                                        <div class="p-label--deprecated secret">Vertraulich</div>
                                        Alternativ einzureichende Dokumente</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
            
                                                ${!!certificate.miscInformation ? `<div>${certificate.miscInformation.replaceAll('tr>', 'TR>')}</div>` : ''}
                  
                                            </div>
                                        </div>
                                    </section>
                                </li>
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Bewertung Schulabschluss</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                                ${certificate.casegroups?.length > 0 ? `
                                                        ${ModalDom.renderCertificateModalSubTable(certificate.casegroups)}
                                                ` : ''}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">
                                        <div class="p-label--deprecated secret">Vertraulich</div>
                                        Zeugnismuster</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${!!hasCertificatePrototypesFiles ? `
                                                ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung', 'Kommentar' ],
            array: certificate.certificateprototypes,
            renderColumns: [ 'nameShort', 'comment' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openCertificatePrototypeInformationModal',
                column: 'nameShort'
            }
        })}
                                                ` : ''}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                ${buildExpertiseElement(expertises, expertisesGfg)}
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderReferenceSubTable(references)}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, certificate._id + 'CertificateWithoutChildren');
    }

    static async openCertificateMsaModal(certificate) {

        if (!(certificate instanceof Object) || !!certificate.isChildCertificate) {
            if (!!certificate._id) {
                certificate = await CertificatesModule.getId(certificate._id);
            } else {
                certificate = await CertificatesModule.getId(certificate);
            }
        }
        const references = await ReferenceModule.getReferenceObject(certificate.reference);
        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);

        const detailViewTemplate = `
        <div custom="CertificateMsaModal" class="p-modal resizable openCertificateMsaModal" aria-hidden="false" aria-controls="false" id="${certificate._id}">
            ${ModalDom.addModalHeader([ { title: 'Land', content: certificate.country?.nameShort, domClass: 'model-header-list' },
            { title: 'Schulabschluss', content: certificate.nameShort, domClass: 'model-header-list' },
            {
                title: 'Informationen',
                content: certificate.hzq ? 'Bewertung dieses Zeugnisses im Hinblick auf den Hochschulzugang anzeigen' : '',
                event: {
                    methodName: 'openCertificateWithoutChildrenModal',
                    methodParameter: certificate._id
                },
                domClass: 'model-header-list'
            },
            { title: 'Kommentar', content: certificate.comment, domClass: 'model-header-list' },
        ])}
            
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Beschreibung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                            
                                            ${buildTransposedTable({
            modelData: certificate,
            renderConfig: [
                { label: 'Übersetzung', field: 'nameGerman' },
                { label: 'Dauer', field: 'regularDuration' },
                { label: 'Kommentar', field: 'adminComment' },
                { label: 'Alternativ einzureichende Dokumente', field: 'miscInformation' },
            ]
        })}
                                            
              
                                        </div>
                                    </div>
                                </section>
                            </li>
                                
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Bewertung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Entsprechender dt. Schulabschluss', 'Kommentar/Bedingungen' ],
            array: certificate.ratings,
            renderColumns: [ 'graduation.nameShort', 'comment' ],
            event: null
        })}
                                        ${!!certificate.ratingComment ? `
                                        <div class="info-text">${certificate.ratingComment.replaceAll('tr>', 'TR>')}</div>
                                        ` : ''}

                                        </div>
                                    </div>
                                </section>
                            </li> 
                                ${buildExpertiseElement(expertises, expertisesGfg)}
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Zeugnismuster</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
        
        
        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung', 'Kommentar' ],
            array: certificate.certificateprototypes,
            renderColumns: [ 'nameShort', 'comment' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openCertificatePrototypeInformationModal',
                column: 'nameShort'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li> 
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderReferenceSubTable(references)}
                                        
                                        </div>
                                    </div>
                                </section>
                            </li>  
                                
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, certificate._id);
    }

    static async openCertificateWithChildrenModal(certificate) {

        if (!this) {
            certificate = await CertificatesModule.getId(certificate);
        }

        const references = await ReferenceModule.getReferenceObject(certificate.reference);
        const hasCertificatePrototypesFiles = certificate.certificateprototypes?.some((prototype) => !!prototype.files?.length);

        const detailViewTemplate = `
        <div custom="CertificateWithChildren" class="p-modal resizable openCertificateWithChildrenModal" aria-hidden="false" aria-controls="false" id="${certificate._id}">
            ${ModalDom.addModalHeader(
            [ { title: 'Land', content: certificate.country?.nameShort },
                { title: 'Schulabschluss', content: certificate.nameShort },
                { title: 'Übersetzung', content: certificate.nameGerman },
                { title: 'Kommentar', content: !!certificate.comment ? `${certificate.comment.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<div class=\"cke-render\">', '').replaceAll('</div>', '').replaceAll('tr>', 'TR>') }` : '' }
            ]
        )
        }
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                        <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Kommentar</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
        
                                            ${!!certificate.adminComment ? `<div>${certificate.adminComment.replaceAll('tr>', 'TR>')}</div>` : ''}
              
                                        </div>
                                    </div>
                                </section>
                            </li>
                                                        
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Alternativ einzureichende Dokumente</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
        
                                            ${!!certificate.miscInformation ? `<div>${certificate.miscInformation.replaceAll('tr>', 'TR>')}</div>` : ''}
              
                                        </div>
                                    </div>
                                </section>
                            </li>
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Unterzeugnisse</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <p>Bitte wählen Sie ein Zeugnis aus!</p>
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung des Zeugnisses', 'Bezeichnung des Zeugnisses auf Deutsch', 'ab', 'bis' ],
            array: certificate.children,
            renderColumns: [ 'nameShort', 'nameGerman', 'validFrom', 'validUntil' ],
            event: {
                entryMethodParameter: [ '_id', certificate.nameShort ],
                entryMethodName: 'openCertificateChildInformationModal',
                column: 'nameShort'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    Zeugnismuster</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
        
        
                                            ${!!hasCertificatePrototypesFiles ? `
                                                ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung', 'Kommentar' ],
            array: certificate.certificateprototypes,
            renderColumns: [ 'nameShort', 'comment' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openCertificatePrototypeInformationModal',
                column: 'nameShort'
            }
        })}
                                                ` : ''}
                                        </div>
                                    </div>
                                </section>
                            </li> 
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderReferenceSubTable(references)}
                                        
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                      </ul>
                    </div>
                </div>
            </div>
        </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, certificate._id);
    }

    static async openCertificateChildInformationModal(certificate, parentCertificateNameShort) {
        await ModalDom.openCertificateWithoutChildrenModal(certificate, parentCertificateNameShort);
    }

    static async openCertificatePrototypeInformationModal(certificatePrototype) {

        if (!this) {
            certificatePrototype = await CertificatesModule.getCertificateprototypeId(certificatePrototype);
        }

        ModalDom.setModalAliasFilename(certificatePrototype);

        const detailViewTemplate = `
            <div class="p-modal resizable openCertificatePrototypeInformationModal" aria-hidden="false" aria-controls="false" id="${certificatePrototype._id}">
               ${ModalDom.addModalHeader([ { title: 'Land', content: certificatePrototype?.country?.nameShort },
                { title: 'Titel des Zeugnismusters', content: certificatePrototype?.nameShort, flagged: 'secret' },
            ]
        )
        }
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Beschreibung</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
          ${buildTransposedTable({
            modelData: certificatePrototype,
            renderConfig: [
                { label: 'Bezeichnung des Zeugnismusters auf Deutsch', field: 'nameGerman' },
                { label: 'Kommentar', field: 'comment' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'PDF-Dokument' ],
                        array: certificatePrototype.files,
                        renderColumns: [ 'alias' ],
                        event: {
                            entryMethodParameter: [ 'path', 'alias', '_id' ],
                            entryMethodName: 'openAttachmentModal',
                            column: 'alias'
                        }
                    })
                }
            ]
        })}
                                                
                                                   </div>
                                        </div>
                                    </section>
                                </li>  
                            
                            </ul>
                    </div>
                </div>
           </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, certificatePrototype._id);
    }

    static async openDocumentModal(document) {

        if (!this) {
            document = await DocumentsModule.getId(document);
        }

        if (document.date) {
            document.date = DatatypeHelper.formattedDate(document.date);
        }
        const references = await ReferenceModule.getReferenceObject(document.reference);

        ModalDom.setModalAliasFilename(document);

        const detailViewTemplate = `
            <div class="p-modal resizable openDocumentModal" aria-hidden="false" aria-controls="false" id="${document._id}">
                                ${ModalDom.addModalHeader([ { title: 'Land', content: document?.country?.nameShort },
                { title: 'Titel des Dokuments', content: document?.title },
            ]
        )
        }
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                                <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Beschreibung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
      
      ${buildTransposedTable({
            modelData: document,
            renderConfig: [
                { label: 'Titel des Dokuments', field: 'title' },
                { label: 'Titel des Dokuments auf Deutsch', field: 'titleGerman' },
                { label: 'Typ des Dokuments', field: 'type.nameShort' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        //https://beige-unimaginable-idols.awork.io/tasks/944f4351-1b6e-ec11-94f6-dc984040d6c7/details
                        tableHeaders: [ 'PDF-Dokument' ],
                        array: document.files,
                        renderColumns: [ 'alias' ],
                        event: {
                            entryMethodParameter: [ 'path', 'alias', '_id' ],
                            entryMethodName: 'openAttachmentModal',
                            column: 'alias'
                        }
                    })
                },
                { label: 'Datum des Dokuments', field: 'date' },
                { label: 'Gültig ab', field: document.validFrom ? 'validFrom' : 'validFromYear' },
                { label: 'Gültig bis', field: document.validUntil ? 'validUntil' : 'validUntilYear' },
                { label: 'Gültig am', field: document.validDate ? 'validDate' : 'validDateYear' },
                { label: 'Kommentar zur Gültigkeit', field: 'validComment' },
                { label: 'Schlagworte', field: 'keywords' },
                { label: 'Zusammenfassung', field: 'summary' },
                { label: 'Herkunft des Dokuments', field: 'origin' },
                { label: 'Kommentar zur Herkunft', field: 'originComment' },
                { label: 'Kommentar zum Dokument', field: 'comment' },
            ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                        </ul>
                    </div>
<!--                </div>-->
<!--           </div>-->
<!--           -->
<!--           <div class="p-modal__dialog" role="dialog">-->
<!--                <div id="modal-description">-->
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                                <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Andere Bezeichnungen für dieses Dokument</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
      
                                                  ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung', 'Sprache', 'Schlagworte', 'Zusammenfassung', 'Kommentar' ],
            array: document.alternativeNames,
            renderColumns: [ 'nameShort', 'language.nameShort', 'keywords', 'summary', 'comment' ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                                                
                                            ${ModalDom.renderReferenceSubTable(references)}          
                                               
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                        </ul>
                    </div>
                </div>
           </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, document._id);
    }

    static async openAttachmentModal(attachment, title, id) {

        if (attachment) {

            const response = await HttpHelper.fetchFileData(`${location.origin}/public/${attachment}`);

            const objectURL = window.URL.createObjectURL(new Blob([ response?.data ], { type: response?.data?.type }));

            const fileHtml = response.status === 404 ? `<p>${response.message}</p>` : response?.data?.type.includes('image') ? `<img src="${objectURL}" id="${id}">` : `<embed src="${objectURL}" id="${id}">`
            if (!!objectURL) {
                const detailViewTemplate = `
                <div class="p-modal resizable openAttachmentModal" aria-hidden="false" aria-controls="false" id="${id}">
                    ${ response.status === 404 ? `${ModalDom.addModalHeader([ {
                        title: response.message, content: title,
                    },
                    ]
                )
                }` : `${ModalDom.addModalHeader([ {
                            title: 'Download', content: title,
                            event:
                                {
                                    methodName: 'downloadAttachment',
                                    methodParameter: `${objectURL}, ${title}`,
                                    customIcon: 'p-icon--begin-downloading'
                                }
                        },
                        ]
                    )
                    }`}
                <div class="p-modal__dialog" role="dialog" style="width: 60vw;height: 60vh">
                    <div id="modal-description" class="height100">
                        <div class="p-accordion">
                            <ul class="p-accordion__list preventXScroll preventYScroll height_attachment">
                                
                                    <li class="p-accordion__group height100">
                                         <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                            <h2 class="p-accordion__title">Vorschau</h2>
                                        </button>
                                        <section class="p-accordion__panel height_attachment preventYScroll" aria-hidden="false">
                                            <div class="row pdf-preview">
                                                <div class="col-14">
                                                   ${fileHtml}
                                                </div>
                                            </div>
                                        </section>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                    </div>
               </div>
            `;
                ModalDom.finishModalElement(detailViewTemplate, id);

            }
        }
    }

    static async downloadAttachment(objectURL, Filename) {
        const link = document.createElement('a');
        link.href = objectURL;
        link.download = Filename;
        document.body.append(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    }

    static async openExpertiseModal(expertise) {

        if (!this) {
            expertise = await ExpertisesModule.getId(expertise);
        }
        const references = ReferenceModule.getReferenceObject(expertise.reference);

        if (expertise.date) {
            if (!!Date.parse(expertise.date) && expertise.date.includes('T')) {
                expertise.date = DatatypeHelper.formattedDate(expertise.date.split('T')[0]);
            }
        }

        ModalDom.setModalAliasFilename(expertise);

        const detailViewTemplate = `
            <div class="p-modal resizable openExpertiseModal" aria-hidden="false" aria-controls="false" id="${expertise._id}">
                                ${ModalDom.addModalHeader([ { title: 'Land', content: expertise.country?.nameShort },
            { title: 'Gutachten', content: expertise.nameShort }
        ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Gutachten</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${buildTransposedTable({
            modelData: expertise,
            renderConfig: [
                { label: 'Titel des Gutachtens', field: 'nameShort' },
                { label: 'Zusätzliche Schlagworte', field: 'keywords' },
                { label: 'Text des Gutachtens', field: 'comment' },
                { label: 'Gutachten erstellt am', field: 'date' },
            ]
        })}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Gutachten für</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente', 'Land' ],
            array: expertise.documents,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                      ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Kapitel des Bildungswesens', 'Land' ],
            array: expertise.bvchapters,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openBvChapterModal',
                column: 'title'
            }
        })}      

                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Dateien</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dateinamen' ],
            array: expertise.files,
            renderColumns: [ 'alias' ],
            event: {
                entryMethodParameter: [ 'path', 'alias', '_id' ],
                entryMethodName: 'openAttachmentModal',
                column: 'alias'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
    
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, expertise._id);
    }

    static async openExpertiseGfgModal(expertise) {

        if (!this) {
            expertise = await ExpertisesModule.getGfgId(expertise);
        }
        const references = await ReferenceModule.getReferenceObject(expertise.reference);
        const referencesCurriculum = await extractDocumentsCurriculumReferences(references, { separateGfg: false } );
        if (expertise.date) {
            if (!!Date.parse(expertise.date) && expertise.date.includes('T')) {
                expertise.date = DatatypeHelper.formattedDate(expertise.date.split('T')[0]);
            }
        }

        ModalDom.setModalAliasFilename(expertise);

        const detailViewTemplate = `
            <div class="p-modal resizable openExpertiseGfgModal" aria-hidden="false" aria-controls="false" id="${expertise._id}ExpertiseGfgModal">
                                ${ModalDom.addModalHeader([ { title: 'Land', content: expertise.country?.nameShort },
            { title: 'Bezeichnung', content: expertise.nameShort }
        ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Gutachten</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${buildTransposedTable({
            modelData: expertise,
            renderConfig: [
                { label: 'Titel des Gutachtens', field: 'nameShort' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'Anzeige/Download des Gutachtens' ],
                        array: expertise.assessment,
                        renderColumns: [ 'alias' ],
                        event: {
                            entryMethodParameter: [ 'path', 'alias', '_id' ],
                            entryMethodName: 'openAttachmentModal',
                            column: 'alias'
                        }
                    })
                },
                { label: 'Registriernummer', field: 'referenceNumber' },
                { label: 'Auftragsart', field: 'productType' },
                { label: 'Erstelldatum des Gutachtens', field: 'date' },
                { label: 'Abschluss', field: 'finishYear' },
                { label: 'Ausbildungsbeginn', field: 'startYear' },
                { label: 'Art des Falls', field: 'type' },
                { label: 'Schlagworte', field: 'keywords' },
            ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Angaben zum GfG-Beruf</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">               ${buildTransposedTable({
            modelData: expertise,
            renderConfig: [
                { label: 'Berufsbezeichnung', field: 'occupationName' },
                { label: 'Verleihende Institution', field: 'institution.nameShort' },
                { label: 'Angestrebte Referenzqualifikation', field: 'desiredQualification' },
                { label: 'Zugeordnete Referenzqualifikation', field: 'assignedQualification' },
                { label: 'Abschlussbezeichnung', field: 'degreeName' },
            ]
        })}
             
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>        
                                                    
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Gutachten für</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
    
        
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Zugehöriges Curriculum</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente', 'Land' ],
            array: referencesCurriculum,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>        
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Zugehörige FNÜ</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente', 'Land' ],
            array: expertise.referencesFNUE,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>      
    
      <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente', 'Land' ],
            array: expertise.documents,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                    
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Kapitel des Bildungswesens', 'Land' ],
            array: expertise.bvchapters,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openBvChapterModal',
                column: 'title'
            }
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                 <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Dateien</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dateinamen' ],
            array: expertise.files,
            renderColumns: [ 'alias' ],
            event: {
                entryMethodParameter: [ 'path', 'alias', '_id' ],
                entryMethodName: 'openAttachmentModal',
                column: 'alias'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, expertise._id + 'ExpertiseGfgModal');
    }

    static async openBvChapterModal(bvChapter) {

        if (!this) {
            bvChapter = await BvChapterModule.getId(bvChapter);
        }
        const references = ReferenceModule.getReferenceObject(bvChapter.reference);

        const detailViewTemplate = `
            <div class="p-modal resizable openBvChapterModal" aria-hidden="false" aria-controls="false" id="${bvChapter._id}">
                                ${ModalDom.addModalHeader([ { title: 'Land', content: bvChapter.country?.nameShort },
            { title: 'Bezeichnung', content: bvChapter.title }
        ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Inhalt des Kapitels</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${!!bvChapter.content ? `${bvChapter.content.replaceAll('tr>', 'TR>')}` : ''}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>              
                                                   
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Informationen zum Bildungswesen Gesundheit</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                                ${bvChapter.informationDocuments?.length > 0 ? '<table class="detail-view">' +
            '<tbody>' +
            '<TR><TH class="ctx-header">Informationen zu den Berufsfeldern</TH></TR>' +
            '</tbody>' +
            '</table>' : ''}
                                                ${buildTransposedTable({
            modelData: bvChapter,
            renderConfig: [
                { label: 'Übersicht', field: 'overview' },
            ]
        })}
                                            
                                           ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente' ],
            array: bvChapter.informationDocuments,
            renderColumns: [ 'title' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                               ${buildTransposedTable({
            modelData: bvChapter,
            renderConfig: [
                { label: 'Kommentar', field: 'documentsComment' },
            ]
        })}
                                                ${bvChapter.sourceDocuments?.length > 0 ? '<table class="detail-view">' +
            '<tbody>' +
            '<TR><TH class="ctx-header">Originalquellen</TH></TR>' +
            '</tbody>' +
            '</table>' : ''}
                                                
                                               ${buildTransposedTable({
            modelData: bvChapter,
            renderConfig: [
                { label: 'Links und Adressen', field: 'sources' },
            ]
        })}
                                                ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dokumente' ],
            array: bvChapter.sourceDocuments,
            renderColumns: [ 'title' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'title'
            }
        })}
                                               ${buildTransposedTable({
            modelData: bvChapter,
            renderConfig: [
                { label: 'Kommentar', field: 'sourcesComment' },
            ]
        })}
                                                
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Unterkapitel</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Kapitel', 'Land' ],
            array: bvChapter.children,
            renderColumns: [ 'title', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openBvChapterModal',
                column: 'title'
            }
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Verweise</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, bvChapter._id);
    }

    static async openOccupationModal(occupation) {
        if (!this) {
            occupation = await OccupationsModule.getId(occupation);
        }

        const references = await ReferenceModule.getReferenceObject(occupation.reference);
        occupation.academicString = '';

        if(!TokenHandler.isLoggedIn() && !!occupation.equivalences?.find(value => value.germanOccupation.nameShort)) {
            occupation.germanEquivalences = '';
            occupation.germanEquivalencesInfo = 'Unter dem Begriff „Referenzqualifikation“ wird der deutsche Beruf genannt, mit dem die ausländische Qualifikation verglichen werden kann. Diese Zuordnung bedeutet nicht, dass die ausländische Qualifikation auch gleichwertig ist. Die Gleichwertigkeit wird ausschließlich über ein Anerkennungsverfahren festgestellt, dass bei der hierfür zuständigen Behörde beantragt werden muss.';
            occupation.equivalences.forEach((value, index) => {
                if(value.germanOccupation?.nameShort)
                    occupation.germanEquivalences += value.germanOccupation?.nameShort;
                if(index !== occupation.equivalences.length -1)
                    occupation.germanEquivalences += ',<br>';
            })
        }

        if (occupation.gfg == true) {
            occupation.gfg = 'gfg';
        }
        if (occupation.academic == true && occupation.nonAcademic == true) {
            occupation.academicString = 'akademisch / nicht akademisch';
        } else if (occupation.academic == true) {
            occupation.academicString = 'akademisch';
        } else if (occupation.nonAcademic == true) {
            occupation.academicString = 'nicht akademisch';
        }

        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);
        const detailViewTemplate = `
        <div class="p-modal resizable openOccupationModal" aria-hidden="false" aria-controls="false" id="${occupation._id}">
                        ${ModalDom.addModalHeader([ { title: 'Land', content: occupation.country?.nameShort },
            { title: 'Beruf', content: occupation.nameShort } ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Beschreibung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                                    ${buildTransposedTable({
            modelData: occupation, renderConfig: [
                {
                    label: 'Beruf',
                    field: 'nameShort',
                }, {
                    label: 'Deutsche Übersetzung',
                    field: 'nameGerman',
                }, {
                    label: 'Beschreibung des Berufs',
                    field: 'description',
                },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: 'Andere Bezeichnungen für diesen Beruf',
                        tableHeaders: [ 'Bezeichnung', 'Sprache', 'Deutsche Übersetzung', 'Kommentar' ],
                        array: occupation.alternativeNames,
                        renderColumns: [ 'nameShort', 'language.nameShort', 'nameGerman', 'comment' ],
                    })
                },
                !!occupation.gfg && (!!occupation.requirements?.length || occupation.requirementCommentAll) ? {
                    header: 'Anforderungen für Berufszugang',
                } : null,
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        tableHeaders: [ 'Anforderungen', 'Kommentar' ],
                        array: occupation.requirements,
                        renderColumns: [ 'requirement', 'comment' ]
                    })
                },
                {
                    field: 'requirementCommentAll',
                    label: 'Kommentar'
                },
                !!occupation.foreignDocuments?.length || (occupation.legalForeignComment && !isEmptyCke.test(occupation.legalForeignComment)) ? {
                    header: 'Rechtsgrundlagen Ausland',
                } : null,
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        tableHeaders: [ 'Dokumente' ],
                        array: occupation.foreignDocuments,
                        renderColumns: [ 'title' ],
                        event: {
                            entryMethodParameter: [ '_id' ],
                            entryMethodName: 'openDocumentModal',
                            column: 'title'
                        }
                    })
                },
                { label: 'Kommentar', field: 'legalForeignComment' },
                !!occupation.informationDocuments?.length || (occupation.infoComment && !isEmptyCke.test(occupation.infoComment)) ? {
                    header: 'Informationen zum Berufsfeld',
                } : null,
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        tableHeaders: [ 'Dokumente' ],
                        array: occupation.informationDocuments,
                        renderColumns: [ 'title' ],
                        event: {
                            entryMethodParameter: [ '_id' ],
                            entryMethodName: 'openDocumentModal',
                            column: 'title'
                        }
                    })
                },
                { label: 'Kommentar', field: 'infoComment' },
                (occupation.comment && !isEmptyCke.test(occupation.comment)) ? { header: 'Kommentar zum Beruf' } : null,
                { contentOverride: occupation.comment, additionalCssClasses: 'default-padding' },
            ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Ausbildung</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                            ${buildTransposedTable({
            modelData: occupation,
            renderConfig: [
                { label: 'Beruf ist im Heimatland', field: 'academicString' },
                { label: 'Kommentar', field: 'degreeCommentAll' },
                (
                    (occupation.degreeAcademicQualification && !isEmptyCke.test(occupation.degreeAcademicQualification))
                    || !!occupation.degreesAcademic?.length
                    || (occupation.degreeAcademicComment && !isEmptyCke.test(occupation.degreeAcademicComment)) ) ? { header: 'Abschlüsse akademisch' } : null,
                { label: 'Vorbildung', field: 'degreeAcademicQualification' },
                {
                    label: 'Dem Beruf liegen folgende akademischen Abschlüsse zugrunde:',
                    field: 'degreesAcademic',
                    event: {
                        methodName: 'openDegreeModal',
                        methodParameterField: '_id'
                    }
                },
                { label: 'Kommentar', field: 'degreeAcademicComment' },
                (
                    (occupation.degreeNonAcademicQualification && !isEmptyCke.test(occupation.degreeNonAcademicQualification))
                    || !!occupation.degreesNonAcademic?.length
                    || (occupation.degreeNonAcademicComment && !isEmptyCke.test(occupation.degreeNonAcademicComment)) ) ? { header: 'Abschlüsse nicht akademisch' } : null,
                { label: 'Vorbildung', field: 'degreeNonAcademicQualification' },
                {
                    label: 'Dem Beruf liegen folgende nicht akademischen Abschlüsse zugrunde:',
                    field: 'degreesNonAcademic',
                    event: {
                        methodName: 'openQualificationsModal',
                        methodParameterField: '_id'
                    }
                },
                { label: 'Kommentar', field: 'degreeNonAcademicComment' },
                (
                    (occupation.degreeEducationalQualification && !isEmptyCke.test(occupation.degreeEducationalQualification))
                    || (occupation.degreeEducationalDescription && !isEmptyCke.test(occupation.degreeEducationalDescription))
                    || (occupation.degreeEducationalComment && !isEmptyCke.test(occupation.degreeEducationalComment)) ) ? { header: 'Abschlüsse schulisch' } : null,
                { label: 'Vorbildung', field: 'degreeEducationalQualification' },
                { label: 'Beschreibung der Ausbildung', field: 'degreeEducationalDescription' },
                { label: 'Kommentar', field: 'degreeEducationalComment' },
            ]
        })}
                                            
                                        </div>
                                    </div>
                                </section>
                            </li>           
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weitere Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                                       ${buildTransposedTable({
            modelData: occupation,
            renderConfig: [
                { label: 'Originalquellen', field: 'originalSource' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'Dokumente', 'Datum des Dokuments' ],
                        array: occupation.referencedDocuments,
                        renderColumns: [ 'title', 'date' ],
                        event: {
                            entryMethodParameter: [ '_id' ],
                            entryMethodName: 'openDocumentModal',
                            column: 'title'
                        }
                    })
                },
                { label: 'Kommentar', field: 'additionalComment' },
            ]
        })}
                                            

                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                             <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Referenzqualifikationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        
                                        ${buildTransposedTable({
                                            modelData: occupation,
                                            renderConfig: [
                                                {
                                                    label: 'Deutsche Referenzqualifikation',
                                                    field: 'germanEquivalences'
                                                },
                                                {
                                                    label: 'Status', field: 'institutionType.status.nameShort', event: {
                                                        methodName: 'openStatusInformationModal',
                                                        methodParameter: ''
                                                    }
                                                },
                                                {
                                                    label: 'Hinweis',
                                                    field: 'germanEquivalencesInfo'
                                                }
                                            ]
                                        })}
                                        <!--occupation.gfg == 'gfg' -->
                                         ${!occupation.germanEquivalences && !!occupation.gfg ? `${buildTransposedTable({
            modelData: occupation,
            renderConfig: [

                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'Äquivalenzklasse', 'Referenzqualifikation', 'Kommentar' ],
                        array: occupation.equivalences,
                        renderColumns: [ 'equivalenceClass', 'germanOccupation.nameShort', 'comment' ],
                        // https://beige-unimaginable-idols.awork.io/tasks/f9df2273-7e4b-ec11-981f-501ac527b592/details
                        // event: {
                        //     entryMethodParameter: 'germanOccupation._id',
                        //     entryMethodName: 'openEquivalenceGermanDegreeTypeInformationModal',
                        //     column: 'germanOccupation.nameShort',
                        //     headerMethodParameter: '',
                        //     headerMethodName: 'openEquivalencesInformationModal',
                        //     headerPos: 0
                        // }
                    })
                },
                {
                    field: 'equivalenceComment', label: 'Kommentar'
                }

            ]
        })}` : ''}

                                        </div>
                                    </div>
                                </section>
                            </li>                     
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Bewertung mit Behördeninformationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${(occupation.ratings?.length > 0 && occupation.gfg != 'gfg') || (!isEmptyCke.test(occupation.internalRatingComment) && occupation.gfg != 'gfg') ? `
                                        ${buildTransposedTable({
            modelData: occupation,
            renderConfig: [
                {
                    label: '',
                    field: 'ratingComment'
                },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride:
                        ModalDom.renderModalSubTable({
                            additionalHeader: null,
                            tableHeaders: [ 'Äquivalenzklasse', 'Entsprechender dt. Beruf', 'Kommentar', 'Behördeninfo' ],
                            array: occupation.ratings,
                            renderColumns: [ 'equivalenceClass', 'germanOccupation.nameShort', 'comment', 'adminComment' ],
                            event: {
                                // entryMethodParameter: 'germanOccupation._id',
                                // entryMethodName: 'openEquivalenceGermanDegreeTypeInformationModal',
                                // column: 'germanOccupation.nameShort',
                                headerMethodParameter: '',
                                headerMethodName: 'openEquivalencesInformationModal',
                                headerPos: 0
                            }
                        })
                },
            ]
        })}` : ''}
                                        </div>
                                    </div>
                                </section>
                            </li>               
                                                 
                            ${buildExpertiseElement(expertises, expertisesGfg)}                      
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Zuständige Stellen in ${occupation.country?.nameShort}</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Name der Stelle', 'Ort', 'Land' ],
            array: occupation.recognitionOffices,
            renderColumns: [ 'nameShort', 'location.originName', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openRecognitionOfficeModal',
                column: 'nameShort'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>                              
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                                                
                                            ${ModalDom.renderReferenceSubTable(references)}          
                                               
                                        </div>
                                    </div>
                                </section>
                            </li>  

                      </ul>
                    </div>
                </div>
            </div>
        </div>
    `;
        ModalDom.finishModalElement(detailViewTemplate, occupation._id);
    }

    static async openInstitutionModal(institution) {
        if (!this) {
            institution = await InstitutionsModule.getId(institution);
        }

        if (institution.blacklisted == true) {
            institution.blacklisted = 'blacklisted';
        }
        const references = await ReferenceModule.getReferenceObject(institution.reference);
        const referencesCurriculum = await extractDocumentsCurriculumReferences(references, { removeGfgReference: true } );
        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);
        const header = [
            { title: 'Land', content: institution.country?.nameShort },
            { title: 'Bildungsinstitution', flagged: { content: institution.nameShort, flag: institution.blacklisted } },
            {
                title: 'Übergeordnete Institution', content: institution.parent?.nameShort, event: {
                    methodName: 'openInstitutionModal',
                    methodParameter: institution.parent?._id
                }
            }
        ]

        const detailViewTemplate = `
        <div class="p-modal resizable openInstitutionModal" aria-hidden="false" aria-controls="false" id="${institution._id}">
                        ${ModalDom.addModalHeader(header)}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Kontakt</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                         ${buildTransposedTable({
            modelData: institution, renderConfig: [
                {
                    label: 'Abkürzung',
                    field: 'abbreviation',
                }, {
                    label: 'Name der Institution auf Deutsch',
                    field: 'nameGerman',
                }, {
                    label: 'Ort',
                    field: 'location.nameShort',
                }, {
                    label: 'Anschrift',
                    field: 'address',
                }, {
                    label: 'Telefon',
                    field: 'phone',
                }, {
                    label: 'Fax',
                    field: 'fax',
                }, {
                    label: 'E-Mail',
                    field: 'email',
                }, {
                    label: 'Homepage',
                    field: 'homepage',
                }, {
                    label: 'Kommentar',
                    field: 'description',
                }, {
                    label: 'Informationen für Behörden &nbsp <div class="p-label--deprecated secret-label">Vertraulich</div>',
                    field: 'administrativeInformation',
                },
            ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                                                        
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Andere Namen für diese Institution</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: 'Name der Institution in einer anderen Sprache',
            tableHeaders: [ 'Name in anderer Sprache', 'Deutsche Übersetzung', 'Kommentar', 'Sprache' ],
            array: institution.alternativeNames,
            renderColumns: [ 'nameShort', 'nameGerman', 'comment', 'language.nameShort' ]
        })}
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: 'Veralteter Name der Institution ',
            tableHeaders: [ 'Veralteter Name', 'Veralteter Name in einer anderen Sprache', 'Deutsche Übersetzung', 'Kommentar', 'Sprache' ],
            array: institution.outdatedNames,
            renderColumns: [ 'nameShort', 'nameTranslated', 'nameGerman', 'comment', 'language.nameShort' ]
        })}
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: 'Aliasname der Institution',
            tableHeaders: [ 'Aliasname', 'Deutsche Übersetzung', 'Kommentar' ],
            array: institution.aliasNames,
            renderColumns: [ 'nameShort', 'nameGerman', 'comment' ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Status</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                            
                                            ${buildTransposedTable({
            modelData: institution,
            renderConfig: [
                institution.blacklisted === 'blacklisted' ? {
                    label: 'Nicht anerkannte Institution <i class="p-icon--warning"></i>',
                    field: 'blacklistedComment',
                    dataFallback: ' '
                } : null,
                {
                    label: 'Institutionstyp',
                    field: 'institutionType.nameShort'
                },
                {
                    label: 'Status', field: 'institutionType.status.nameShort', event: {
                        methodName: 'openStatusInformationModal',
                        methodParameter: ''
                    }
                },
                {
                    label: 'Kommentar',
                    field: 'institutionType.comment'
                }
            ]
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Abschlüsse</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Abschlussbezeichnung', 'Abschlusstyp', 'Abschlussklasse', 'Land' ],
            array: institution.degrees,
            renderColumns: [ 'nameShort', 'degreeType.nameShort', 'degreeType.degreeclass.nameShort', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDegreeModal',
                column: 'nameShort'
            }
        })}
                                        </div>
                                    </div>
                                </section>
                            </li>  
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">
                                    <div class="p-label--deprecated secret">Vertraulich</div>
                                    GfG-Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Beruf', 'Dokumentenart', 'Datum des Dokuments' ],
            array: referencesCurriculum,
            renderColumns: [ 'occupationsNameShortList', 'type.nameShort', 'date' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDocumentModal',
                column: 'type.nameShort'
            }
        })}
                                        ${buildTransposedTable({
            modelData: institution,
            renderConfig: [ {
                label: 'Qualität der Institution',
                field: 'quality'
            } ]
        })}

                                        </div>
                                    </div>
                                </section>
                            </li>  
                               ${buildExpertiseElement(expertises, expertisesGfg)}    
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                            ${ModalDom.renderReferenceSubTable(references)}
                                        
                                        </div>
                                    </div>
                                </section>
                            </li>  

                      </ul>
                    </div>
                </div> 
            </div>
        </div>
    `;
        ModalDom.finishModalElement(detailViewTemplate, institution._id);

        if (institution.children?.length !== 0 && !document.querySelector(`[name=childSelect-${institution._id}]`)) {
            const selectElem = document.createElement('SELECT');
            selectElem.onchange = (event) => {
                if (event.target.value === 'null') return;
                ModalDom.openInstitutionModal.call(null, event.target.value).then()
            }
            selectElem.setAttribute('name', `childSelect-${institution._id}`)
            selectElem.style.maxWidth = '50%';
            const emptyOption = document.createElement('OPTION')
            emptyOption.setAttribute('value', null);
            emptyOption.innerText = 'Zugehörige Institution öffnen';
            selectElem.append(emptyOption);
            institution.children.sort((a, b) => a.nameShort.localeCompare(b.nameShort));
            selectElem.append(
                ...institution.children.map(child => {
                    const option = document.createElement('OPTION')
                    option.setAttribute('value', child._id);
                    option.innerText = child.nameShort;
                    return option
                })
            )

            const rowOuter = document.createElement('DIV')
            rowOuter.setAttribute('class', 'row header-padding')
            const col12 = document.createElement('DIV')
            col12.setAttribute('class', 'col-12')
            const rowInner = document.createElement('DIV')
            rowInner.setAttribute('class', 'row')
            const label = document.createElement('LABEL')
            label.setAttribute('for', `childSelect-${institution._id}`)
            label.innerHTML = '<strong>Zugehörige Institutionen:</strong>'
            rowInner.append(label)
            rowInner.append(selectElem)
            col12.append(rowInner)
            rowOuter.append(col12)
            const modalHeader = document.getElementById(institution._id).querySelector('.p-modal__header')
            modalHeader.append(rowOuter)
        }
    }

    static async openEquivalenceGermanDegreeTypeInformationModal(equivalenceDegreeType) {
        if (!this) {
            equivalenceDegreeType = await DegreeTypesModule.getId(equivalenceDegreeType);
        }

        const detailViewTemplate = `
            <div class="p-modal resizable openEquivalenceGermanDegreeTypeInformationModal" aria-hidden="false" id="${equivalenceDegreeType._id}">
                                ${ModalDom.addModalHeader([ {
            title: 'Land',
            content: equivalenceDegreeType.country?.nameShort
        },
            { title: 'Abschlusstyp', content: equivalenceDegreeType.nameShort } ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Beschreibung</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                                ${buildTransposedTable({
            modelData: equivalenceDegreeType,
            renderConfig: [
                {
                    label: 'Abschlusstyp',
                    field: 'nameShort'
                }, {
                    label: 'Abschlussklasse',
                    field: 'degreeclass.nameShort',
                    event: {
                        methodName: 'openDegreeClassInformationModal',
                        methodParameter: equivalenceDegreeType.degreeclass?._id
                    }
                }, {
                    label: 'Kommentar',
                    field: 'comment'
                }
            ]
        })}
        
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, equivalenceDegreeType._id);
    }

    static async openRecognitionOfficeModal(recognitionOffice) {

        if (!this) {
            recognitionOffice = await RecognitionOfficeModule.getId(recognitionOffice);
        }

        const references = await ReferenceModule.getReferenceObject(recognitionOffice.reference);

        const expertises = [];
        const expertisesGfg = [];

        if (references?.out.length > 0) {
            const indexToRemove = [];
            for (let i = 0; i < references?.out.length; i++) {
                if (references.out[i]?.key === 'Expertise') {
                    indexToRemove.push(i);
                    if (!!references.out[i]?.object.gfg) {
                        expertisesGfg.push(await ExpertisesModule.getId(references.out[i]?.object._id));
                    } else {
                        expertises.push(await ExpertisesModule.getId(references.out[i]?.object._id));
                    }
                }
            }
            references.out = references.out.filter((reference, index) => !indexToRemove.includes(index));
        }


        const detailViewTemplate = `
             <div class="p-modal resizable openRecognitionOfficeModal" aria-hidden="false" aria-controls="false" id="${recognitionOffice._id}">
                                 ${ModalDom.addModalHeader([ {
            title: 'Land',
            content: recognitionOffice.country?.nameShort
        }, { title: 'Stelle', content: recognitionOffice.nameShort },
            { title: 'Abkürzung', content: recognitionOffice.abbreviation } ])}
                <div class="p-modal__dialog" role="dialog">
                    <div id="modal-description">
                        <div class="p-accordion">
                            <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Zuständige Stelle</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${buildTransposedTable({
            modelData: recognitionOffice,
            renderConfig: [
                { label: 'Ort', field: 'location.originName' },
                { label: 'Anschrift', field: 'address' },
                { label: 'Telefon', field: 'phone' },
                { label: 'Fax', field: 'fax' },
                { label: 'E-Mail', field: 'email' },
                { label: 'Homepage', field: 'homepage' },
                { label: 'Homepage (alternativ)', field: 'homepageAlt' },
                { label: 'Zuständig für', field: 'responsibleFor' },
                { label: 'Kommentar', field: 'responsibility' },
            ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                 <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Zuständigkeiten</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung des Berufs', 'Bezeichnug des Berufs auf Deutsch (Übersetzung)', 'Land' ],
            array: recognitionOffice.occupations,
            renderColumns: [ 'nameShort', 'nameGerman', 'country.nameShort' ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                              
                                
                                 <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Mustergutachten <div class="p-label--deprecated secret">Vertraulich</div></h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Titel des Gutachtens', 'Erstelldatum', 'Art des Falls', 'Land' ],
            array: expertises,
            renderColumns: [ 'nameShort', 'date', 'type', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openExpertiseModal',
                column: 'nameShort'
            }
        })}
                     </div>
                                    </div>
                                </section>
                            </li>        
                                
                                
                                  <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Ansprechpartner</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">

${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Name', 'Adresszusatz', 'Telefon', 'Fax', 'E-Mail', 'Sprechzeiten' ],
            array: recognitionOffice.contacts,
            renderColumns: [ 'name', 'address', 'phone', 'fax', 'email', 'consultations' ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Verweise</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, recognitionOffice._id);
    }

    static async openDocumentsCurriculaGfgModal(documentsCurriculaGfg) {

        if (!this) {
            documentsCurriculaGfg = await DocumentsCurriculaGfgModule.getId(documentsCurriculaGfg);
        }

        const references = await ReferenceModule.getReferenceObject(documentsCurriculaGfg.reference);

        documentsCurriculaGfg.validFromFormatted = DatatypeHelper.formattedDate(documentsCurriculaGfg.validFrom ?? documentsCurriculaGfg.validFromYear) ?? null;
        documentsCurriculaGfg.validUntilFormatted = DatatypeHelper.formattedDate(documentsCurriculaGfg.validUntil ?? documentsCurriculaGfg.validUntilYear) ?? null;
        documentsCurriculaGfg.validDateFormatted = DatatypeHelper.formattedDate(documentsCurriculaGfg.validDate ?? documentsCurriculaGfg.validDateYear) ?? null;
        documentsCurriculaGfg.dateFormatted = DatatypeHelper.formattedDate(documentsCurriculaGfg.date) ?? null;

        ModalDom.setModalAliasFilename(documentsCurriculaGfg);

        const detailViewTemplate = `
             <div class="p-modal resizable openDocumentsCurriculaGfgModal" aria-hidden="false" aria-controls="false" id="${documentsCurriculaGfg._id}">
                                 ${ModalDom.addModalHeader([ {
            title: 'Land',
            content: documentsCurriculaGfg.country?.nameShort
        },
            { title: 'Dokuments', content: documentsCurriculaGfg.title },
            { title: 'Typ', content: documentsCurriculaGfg.type.nameShort }
        ])}
                <div class="p-modal__dialog" role="dialog">
                    <div id="modal-description">
                        <div class="p-accordion">
                            <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Dokument</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            
                                            ${buildTransposedTable({
            modelData: documentsCurriculaGfg,
            renderConfig: [
                { label: 'Titel des Dokuments', field: 'title' },
                { label: 'Titel des Dokuments auf Deutsch', field: 'titleGerman' },
                { label: 'Typ des Dokuments', field: 'type.nameShort' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'PDF-Dokument' ],
                        array: documentsCurriculaGfg.files,
                        renderColumns: [ 'alias' ],
                        event: {
                            entryMethodParameter: [ 'path', 'alias', '_id' ],
                            entryMethodName: 'openAttachmentModal',
                            column: 'alias'
                        }
                    })
                },
                { label: 'Datum des Dokuments', field: 'dateFormatted' },
                { label: 'Gültig ab', field: 'validFromFormatted' },
                { label: 'Gültig bis', field: 'validUntilFormatted' },
                { label: 'Gültig am', field: 'validDateFormatted' },
                { label: 'Kommentar zur Gültigkeit', field: 'validComment' },
                { label: 'Schlagworte', field: 'keywords' },
                { label: 'Zusammenfassung', field: 'summary' },
                { label: 'Herkunft des Dokuments', field: 'origin' },
                { label: 'Kommentar zur Herkunft', field: 'originComment' },
                { label: 'Kommentar zum Dokument', field: 'comment' },
            ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Andere Bezeichnungen für dieses Dokument</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Bezeichnung', 'Sprache', 'Schlagworte', 'Zusammenfassung', 'Kommentar' ],
            array: documentsCurriculaGfg.alternativeNames,
            renderColumns: [ 'nameShort', 'language.nameShort', 'keywords', 'summary', 'comment' ]
        })}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, documentsCurriculaGfg._id);
    }

    static async openResponsibleOfficeModal(responsibleOffice) {

        if (!this) {
            responsibleOffice = await ResponsibleOfficeModule.getId(responsibleOffice);
        }

        const references = await ReferenceModule.getReferenceObject(responsibleOffice.reference);


        const detailViewTemplate = `
             <div class="p-modal resizable openResponsibleOfficeModal" aria-hidden="false" aria-controls="false" id="${responsibleOffice._id}">
                                 ${ModalDom.addModalHeader([ {
            title: 'Stellenname',
            content: responsibleOffice?.nameShort
        },
            { title: 'Bundesland', content: responsibleOffice?.countryZone?.nameOrigin } ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Zuständige Stelle</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${buildTransposedTable({
            modelData: responsibleOffice,
            renderConfig: [


                { label: 'Ort', field: 'location' },
                { label: 'Anschrift', field: 'address' },
                { label: 'Abkürzung', field: 'abbreviation' },
                { label: 'Telefon', field: 'phone' },
                { label: 'Fax', field: 'fax' },
                { label: 'E-Mail', field: 'email' },
                { label: 'Homepage', field: 'homepage' },
                { label: 'Homepage2', field: 'homepageAlt' },
                { label: 'Kommentar', field: 'comment' },
            ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Zuständigkeiten</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Name der Zuständigkeit', 'Bundesländer', 'Kommentar' ],
            array: responsibleOffice.relatedcompetences,
            renderColumns: [ 'competence.nameShort', 'competence.state', 'comment' ]
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Verweise</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                          </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, responsibleOffice._id);
    }

    static async openDegreeTypeInformationModal(degreeType) {

        if (!this) {
            degreeType = await DegreeTypesModule.getId(degreeType);
        }

        const references = await ReferenceModule.getReferenceObject(degreeType.reference);
        const [ expertises, expertisesGfg ] = await extractExpertiseReferences(references);

        const detailViewTemplate = `
            <div class="p-modal resizable openDegreeTypeInformationModal" aria-hidden="false" id="${degreeType._id}">
                                ${ModalDom.addModalHeader([ { title: 'Land', content: degreeType.country?.nameShort },
            { title: 'Abschlusstyp', content: degreeType.nameShort } ])}
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Beschreibung</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
          ${buildTransposedTable({
            modelData: degreeType,
            renderConfig: [
                { label: 'Abschlusstyp', field: 'nameShort' },
                { label: 'Abschlusstyp (deutsche Übersetzung)', field: 'nameGerman' },
                { label: 'Abschlusstyp (weibl.)', field: 'nameFemale' },
                { label: 'Abschlusstyp (weibl., deutsche Übersetzung)', field: 'nameFemaleGerman' },
                { label: 'Abkürzung', field: 'abbreviation' },
                { label: 'Abkürzung (weibl.)', field: 'abbreviationFemale' },
                {
                    label: 'Abschlussklasse', field: 'degreeclass.nameShort', event: {
                        methodName: 'openDegreeClassInformationModal',
                        methodParameter: ''
                    }
                },
                { label: 'Kommentar', field: 'comment' },
                {
                    additionalCssClasses: 'u-no-padding', contentOverride: ModalDom.renderModalSubTable({
                        additionalHeader: null,
                        tableHeaders: [ 'Andere Bezeichnung für diesen Abschlusstyp', 'Sprache', 'Deutsche Übersetzung', 'Kommentar' ],
                        array: degreeType.alternativeNames,
                        renderColumns: [ 'nameShort', 'language.nameShort', 'nameGerman', 'comment' ],
                    })
                }
            ]
        })}
                                            
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Vorbildung und Studium</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
            ${!degreeType.hideRequirement ? `${buildTransposedTable({
            modelData: degreeType,
            renderConfig: [
                { label: 'Eingangsvoraussetzung', field: 'requirement' },
                { label: 'Zusätzliche Anforderungen', field: 'additionalRequirement' },
            ]
        })}` : ''} 
            
            ${!degreeType.hideStudies ? `${buildTransposedTable({
            modelData: degreeType,
            renderConfig: [
                { label: 'Studiendauer (min)', field: 'studiesMinLength', displayAfterContent: ' Jahr(e)' },
                { label: 'Studiendauer (max)', field: 'studiesMaxLength', displayAfterContent: ' Jahr(e)' },
                { label: 'Erläuterung zur Studiendauer', field: 'explanationStudiesLength' },
                { label: 'Beschreibung des Studiums', field: 'studiesDescription' },
            ]
        })}` : ''}
    
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Bewertung</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Äquivalenzklasse', 'Entsprechender dt. Abschlusstyp', 'Kommentar' ],
            array: degreeType.equivalences,
            renderColumns: [ 'equivalenceClass', 'degreeType.nameShort', 'comment' ],
            event: {
                entryMethodParameter: 'degreeType._id',
                entryMethodName: 'openEquivalenceGermanDegreeTypeInformationModal',
                column: 'degreeType.nameShort',
                headerMethodParameter: '',
                headerMethodName: 'openEquivalencesInformationModal',
                headerPos: 0
            }
        })}
                                                
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">
                                        <div class="p-label--deprecated secret">Vertraulich</div>
                                        Behördeninformationen zur Bewertung</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${buildTransposedTable({
            modelData: degreeType,
            renderConfig: [
                { label: 'Hinweise zur Gradführung', field: 'degreeAdministrativeInformation' },
                { label: 'Hinweise zur Umwandlung', field: 'degreeTransformationInformation' },
                { label: 'Hinweise zum Promotionszugang', field: 'graduationAccessInformation' },
                { label: 'Hinweise zum Masterstudium', field: 'masterAccessInformation' },
                {
                    label: 'Hinweise zum Hochschulzugang bzw. zur Anrechnung von Studienleistungen',
                    field: 'universityAccessInformation'
                },
                { label: 'Anerkennung im beruflichen Bereich', field: 'occupationalRecognition' },
            ]
        })}
                                            
                                                
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Abschlüsse</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                            ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Abschlussbezeichnung', 'Studienrichtung', 'Land' ],
            array: degreeType.degrees,
            renderColumns: [ 'nameShort', 'fieldOfStudy.nameShort', 'country.nameShort' ],
            event: {
                entryMethodParameter: '_id',
                entryMethodName: 'openDegreeModal',
                column: 'nameShort'
            }
        })}
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                ${buildExpertiseElement(expertises, expertisesGfg)}
                                <li class="p-accordion__group">
                                     <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                        <h2 class="p-accordion__title">Weiterführende Informationen</h2>
                                    </button>
                                    <section class="p-accordion__panel" aria-hidden="false">
                                        <div class="row">
                                            <div class="col-14">
                                            
                                                ${ModalDom.renderReferenceSubTable(references)}
                                            
                                            </div>
                                        </div>
                                    </section>
                                </li>  
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, degreeType._id);
    }

    static openEquivalencesInformationModal() {

        const detailViewTemplate = `
            <div class="p-modal resizable openEquivalencesInformationModal" aria-hidden="false" id="equivalencesInformation">
                                ${ModalDom.addModalHeader([ { title: 'Äquivalenzklassen' } ])}
                <div class="p-modal__dialog" role="dialog">
                    <div id="modal-description">
                        <p>Die Äquivalenzfeststellung erfolgt durch Zuordnung ausländischer Abschusstypen und Abschlüsse zu deutschen Abschlusstypen. Dabei werden drei Äquivalenzklassen unterschieden:</p>
                        <ol style="margin-bottom: 1rem">
                            <li>Bedingt vergleichbar</li>
                            <li>Entspricht</li>
                            <li>Gleichwertig</li>
                        </ol>
                        <h2 style="margin-bottom: 1rem">Definition der Äquivalenzklassen:</h2>
                        <table class="detail-table">
                            <tr>
                                <th>Klasse</th>
                                <th>Definition</th>
                            </tr>
                            <tr>
                                <td>Bedingt vergleichbar</td>
                                <td>Der ausländische Abschlusstyp/Abschluss ist dem deutschen Abschlusstyp<br> formal aber nicht materiell gleichwertig.</td>
                            </tr>
                            <tr>
                                <td>Entspricht</td>
                                <td>Der ausländische Abschlusstyp/Abschluss ist dem deutschen Abschlusstyp<br> formal gleichwertig. Zur materiellen Gleichwertigkeit wird keine Aussage gemacht.</td>
                            </tr>
                            <tr>
                                <td>Gleichwertig</td>
                                <td>Der ausländische Abschlusstyp/Abschluss ist dem deutschen Abschlusstyp<br> formal und materiell gleichwertig.</td>
                            <ul/>
                        </table>
                        <div class="row">
                            <h2>Hinweis:</h2>
                            <p>Die allgemeine Zuordnung zu Äquivalenzklassen stellt keine Anerkennungsentscheidung dar und kann die konkrete Gleichwertigkeitsfeststellung der zuständigen Anerkennungsbehörde nicht vorwegnehmen.</p>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate.replaceAll('tr>', 'TR>'), 'equivalencesInformation');
    }

    static openStatusInformationModal() {

        const detailViewTemplate = `
            <div class="p-modal resizable openStatusInformationModal" aria-hidden="false" id="statusInformationModal">
                                ${ModalDom.addModalHeader([ { title: 'Status' } ])}
                <div class="p-modal__dialog" role="dialog">
                    <div id="modal-description">
                        <p>Mit der Kategorie "Status" antwortet anabin auf eine der am häufigsten gestellten Fragen soweit möglich bereits auf der Ebene des Institutionstyps: Ist eine ausländische Bildungseinrichtung als Hochschule "anerkannt" oder nicht? Die drei verwendeten Kategorien sind wie folgt definiert:</p>
                        <div class="">
                            <ul class="row detail-table-header">
                                <li class="col-3">Klasse</li>
                                <li class="col-9">Definition</li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">H +</li>
                                <li class="col-9">Die Institutionen dieses Typs sind im jeweiligen Herkunftsland in maßgeblicher Weise als Hochschulen anerkannt (akkreditiert, attestiert u.a.) und ausgehend davon in Deutschland als Hochschulen anzusehen.

                                                    Besonders für Länder der ehemaligen sozialistischen Welt sind auch Forschungsinstitute erfasst, da an ihnen Promotionen und Habilitationen möglich sind. Da diese Qualifikationen denen an Hochschulen gleichwertig sind, werden die Forschungsinstitute ebenfalls dieser Kategorie zugeordnet.

                                                    Achtung!
                                                    Die Einstufung als H+ bedeutet lediglich, dass Abschlüsse, die an dieser Einrichtung erreicht wurden einer Gleichwertigkeitsuntersuchung im Hochschulbereich unterzogen werden können. Eine Vorentscheidung darüber, ob die Abschlüsse dieser Einrichtung deutschen Hochschulabschlüssen gleichgestellt werden können, ist damit nicht verbunden. </li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">H -</li>
                                <li class="col-9">Institutionen dieses Institutionstyps sind vorläufig oder auf Dauer nicht als Hochschulen anzusehen. Es handelt sich nicht um eine homogene Gruppe. Im Wesentlichen sind zwei Fallgruppen unterscheidbar:
                                    <div style="padding-top: 1em;"></div>
                                    <ul class="dash-list">
                                        <li>
                                            Die Institutionen sind ihrem Anspruch nach Hochschulen, im Herkunftsland (derzeit) aber nicht in maßgeblicher oder nachvollziehbarer Weise als Hochschulen anerkannt (akkreditiert, attestiert u.a.) und ausgehend davon in Deutschland (derzeit) nicht als Hochschulen zu behandeln.
                                        </li>
                                        <li>
                                            Die Institutionen dieses Institutionstyps sind dem Anspruch nach und auch entsprechend ihrem rechtlichen Status im Herkunftsland keine Hochschulen, sondern z.B. Fachschulen.
                                        </li>
                                    </ul>       
                                </li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">H +/-</li>
                                <li class="col-9">Für diese Institutionen ist auf der Ebene des Institutionstyps eine einheitliche Statusfestlegung nicht möglich. Auch diese Gruppe ist nicht homogen. Unter anderem lassen sich zwei Fallgruppen unterscheiden:
                                    <div style="padding-top: 1em;"></div>
                                    <ul class="dash-list">
                                        <li>
                                            Der Typ umfasst sowohl anerkannte als auch nicht anerkannte Institutionen.
                                        </li>
                                        <li>
                                            Im Herkunftsland findet im Hinblick auf die Institutionen eine Statusfestlegung nicht statt. Anerkennung (Akkreditierung, Attestierung u.a.) betrifft im Herkunftsland ausschließlich die Studiengänge/Abschlüsse.
                                        </li>
                                    </ul>             
                                </li>
                            <ul/>
                        </div>
                        <div class="row">
                            <h2>Hinweis:</h2>
                            <p>Die genannten nachgeordneten Fallgruppen werden der Übersichtlichkeit halber in der Statuskategorisierung nicht aufgegriffen. Entsprechende Hinweise ergeben sich oft schon aus der Benennung des Institutionstyps, sie können in den "Allgemeinen Informationen" oder auch bei den einzelnen Institutionen zu finden sein. Es ist zu unterstreichen, dass über die Statusfestlegung eine Äquivalenzfeststellung oder Bewertung von Hochschuleinrichtungen in anabin nicht stattfindet. Im Gegensatz zu einer verbreiteten Erwartung wird z.B. nicht auf die Frage geantwortet, ob eine ausländische Einrichtung einer deutschen Universität oder einer deutschen Fachhochschule entspricht. Äquivalenzfestlegungen und Bewertungen finden, was den Hochschulbereich anbelangt, ausschließlich bei "Abschlusstypen" und "Abschlüssen" statt.</p>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, 'statusInformationModal');
    }

    static openDegreeClassInformationModal() {

        const detailViewTemplate = `
            <div class="p-modal resizable openDegreeClassInformationModal" aria-hidden="false" id="degreeClassInformationModal">
                ${ModalDom.addModalHeader([ { title: 'Abschlussklassen' } ])}
                <div class="p-modal__dialog" role="dialog">
                    <div id="modal-description">
                        <p>Es handelt sich um ein Länderübergreifendes Klassifizierungssystem für Abschlusstypen mit beschreibendem, nicht bewertendem Charakter. Basis für die Klassifizierung ist im Kernbereich die typische Studiendauer des jeweiligen Abschlusstyps. Die Studiendauer einzelner Abschlüsse innerhalb des jeweiligen Abschlusstyps kann abweichen. Die Klassifizierungsskala umfasst die folgenden Positionen: </p>
                        <div class="col-14">
                            <ul class="row detail-table-header">
                                <li class="col-3">Klasse</li>
                                <li class="col-9">Definition</li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">A2</li>
                                <li class="col-9">
                                    Abschlusstyp für Studien-/Ausbildungsgänge mit einer typischen Normdauer von weniger als drei Jahren 
                                </li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">A3</li>
                                <li class="col-9">
                                    Abschlusstyp für Studien-/Ausbildungsgänge mit einer typischen Normdauer von weniger als vier Jahren 
                                </li>
                            </ul>
                            <ul class="row detail-table-body">
                                <li class="col-3">A4</li>
                                <li class="col-9">
                                     Abschlusstyp für Studiengänge mit einer typischen Normdauer von vier Jahren 
                                </li>
                            </ul>                       
                            <ul class="row detail-table-body">
                                <li class="col-3">A5</li>
                                <li class="col-9">
                                     Abschlusstyp für Studiengänge mit einer typischen Normdauer von mehr als vier Jahren 
                                </li>
                            </ul>               
                            <ul class="row detail-table-body">
                                <li class="col-3">PGS</li>
                                <li class="col-9">
                                    Postgraduale Studienangebote
                                </li>
                            </ul>                          
                            <ul class="row detail-table-body">
                                <li class="col-3">D1</li>
                                <li class="col-9">
                                    Promotion
                                </li>
                            </ul>                         
                            <ul class="row detail-table-body">
                                <li class="col-3">D2</li>
                                <li class="col-9">
                                    Habilitation
                                </li>
                            </ul>                            
                            <ul class="row detail-table-body">
                                <li class="col-3">HC</li>
                                <li class="col-9">
                                    Ehrengrad oder Ehrentitel
                                </li>
                            </ul>                           
                            <ul class="row detail-table-body">
                                <li class="col-3">NZ</li>
                                <li class="col-9">
                                    Nicht zugeordnet, weil die entsprechende Information fehlt oder weil sich der Abschlusstyp einer entsprechenden Klassifizierung nicht fügt.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, 'degreeClassInformationModal');
    }

    static async openNewsModal(news) {

        if (!this) {
            news = await NewsModule.getId(news);
        }

        if (Array.isArray(news.newsgroups)) {
            const tempArray = news.newsgroups;
            news.newsgroups = '';
            tempArray.forEach((entry, index) => {
                news.newsgroups += entry.title;
                if (index !== (tempArray.length - 1)) {
                    news.newsgroups += ', ';
                }
            });
        }

        ModalDom.setModalAliasFilename(news);

        const detailViewTemplate = `
        <div class="p-modal resizable openCertificateWithChildrenModal" aria-hidden="false" aria-controls="false" id="${news._id}">
                        ${ModalDom.addModalHeader(
            [ { title: 'Land', content: news.title },
                { title: 'Thema', content: news.subtitle },
                { title: 'Datum', content: DatatypeHelper.formattedDate(news.date) },
            ]
        )
        }
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <div class="p-accordion__list preventXScroll">
                            
                            <div class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">News</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                            
                                            ${news.short ? `<h3>${news.short}</h3>` : ''}
                                            ${news.bodytext ? `<p>${news.bodytext}</p>` : ''}
              
                                        </div>
                                    </div>
                                </section>
                            </div>  
                            
                            <div class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Dateien</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                        ${ModalDom.renderModalSubTable({
            additionalHeader: null,
            tableHeaders: [ 'Dateinamen' ],
            array: news.files,
            renderColumns: [ 'alias' ],
            event: {
                entryMethodParameter: [ 'path', 'alias', '_id' ],
                entryMethodName: 'openAttachmentModal',
                column: 'alias'
            }
        })}
                                        
                                        </div>
                                    </div>
                                </section>
                            </div>  
                            
                      </div>
                    </div>
                </div>
            </div>
        </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, news._id);
    }

    static async openFaqModal(faq) {

        if (!this) {
            faq = await FaqModule.getId(faq);
        }

        const detailViewTemplate = `
        <div class="p-modal resizable openCertificateWithChildrenModal" aria-hidden="false" aria-controls="false" id="${faq._id}">
                        ${ModalDom.addModalHeader(
            [ { title: 'Themenbereich', content: faq.group?.nameShort },
                { title: 'Thema', content: faq.category?.nameShort }
            ]
        )
        }
            <div class="p-modal__dialog" role="dialog">
                <div id="modal-description">
                    <div class="p-accordion">
                        <ul class="p-accordion__list preventXScroll">
                            
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Frage</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                            <p>${faq.question ?? ''}</p>
              
                                        </div>
                                    </div>
                                </section>
                            </li>                              
                            <li class="p-accordion__group">
                                 <button type="button" class="p-accordion__tab--with-title" aria-expanded="true">
                                    <h2 class="p-accordion__title">Antwort</h2>
                                </button>
                                <section class="p-accordion__panel" aria-hidden="false">
                                    <div class="row">
                                        <div class="col-14">
                                        
                                            <p>${faq.answer ?? ''}</p>
              
                                        </div>
                                    </div>
                                </section>
                            </li>  

                      </ul>
                    </div>
                </div>
            </div>
        </div>
        `;
        ModalDom.finishModalElement(detailViewTemplate, faq._id);
    }

    static toggleAccordion(btn) {
        btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'false' ? 'true' : 'false');
        btn.nextElementSibling.setAttribute('aria-hidden', btn.nextElementSibling.getAttribute('aria-hidden') === 'false' ? 'true' : 'false');

    }

    static filterEmptyDetailViewEntries() {
        const detailViews = document.querySelectorAll('.p-accordion__group > section > div > div');
        const emptyDetailViews = Array.from(detailViews).filter(el => el.children.length === 0);
        emptyDetailViews.forEach(el => el.closest('.p-accordion__group').remove())
    }

    static removeModal(id) {
        document.getElementById(id)?.remove();
        const modalDrawer = document.querySelector('#modalDrawer');
        const pageWrapper = document.querySelector('.page-wrapper');
        const modalOrderHandler = pageWrapper.querySelector('#modalOrderHandler');

        if (!modalDrawer.children.length) {
            modalDrawer.classList.add('d-none');
            pageWrapper.removeChild(modalOrderHandler);

            const body = document.querySelector('body');
            body.classList.remove('preventYScroll');
        } else {
            ModalDom.hideModalOrderHandler(modalDrawer, modalOrderHandler);
        }
    }

    static finishModalElement(template, modalId) {
        const modal = ModalDom.modalIdExists(modalId);
        const body = document.querySelector('body');
        body.classList.add('preventYScroll');
        if (!modal) {
            const detailView = HtmlHelper.createElementFromHTML(template);
            ModalDom.setModalEventListener(detailView, modalId);
            HtmlHelper.dragElement(detailView);
            const modalDrawer = document.querySelector('#modalDrawer');
            modalDrawer.appendChild(detailView);
            if (modalDrawer.children.length) {
                modalDrawer.classList.remove('d-none');
            }
            const modal = document.getElementById(modalId)
            modal.style.top = (window.innerHeight - modal.clientHeight) / 2 + 'px'
            modal.style.left = (window.innerWidth - modal.clientWidth) / 2 + 'px'
            ModalDom.filterEmptyDetailViewEntries();
            ReferenceModule.manipulateHtml();
            ModalDom.setModalOrderHandler(detailView, modalId);
        } else {
            ModalDom.reOrder(modalId);
            HtmlHelper.resetCssAnimation(modal, 'modal-flash-once');
        }
        ModalDom.renderModalOrderHandler();
        HtmlHelper.initialiseHiddenMails();
    }

    static setModalEventListener(dom, modalId) {
        dom.lastElementChild.addEventListener('animationend', function (event) {
            event.target.classList.remove('modal-flash-once');
        });
        dom.querySelector('#minimizeModalButton').addEventListener('click', function (e) {
            toggleMinimizeModal(e, modalId);
        });
        dom.querySelector('#maximizeModalButton').addEventListener('click', function (e) {
            toggleMaximizeModal(e, modalId);
        });
        dom.querySelector('#removeModalButton').addEventListener('click', function () {
            ModalDom.removeModal(modalId);
        });
        dom.querySelector('#printModalButton').addEventListener('click', function () {
            ModalDom.printPageArea(modalId);
        });
        dom.querySelectorAll('.p-accordion__group > button').forEach((element) => {
            element.addEventListener('click', function () {
                ModalDom.toggleAccordion(this);
            });
        });
        dom.querySelectorAll('.clickable').forEach((element) => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                const dynamicFunction = getFunctionByName(element.id, this);
                let dynamicParameter = '';
                const dynamicParameterArray = element.attributes.getNamedItem('parameter')?.nodeValue.split(',');
                if (dynamicParameterArray) {
                    dynamicFunction(...dynamicParameterArray);
                } else {
                    dynamicParameter = element.attributes.getNamedItem('parameter')?.nodeValue;
                    dynamicFunction(dynamicParameter);
                }
            });
        });

    }

    static setModalOrderHandler(dom, modalId) {
        dom.addEventListener('click', (event) => {
            if (event.currentTarget.classList.contains('minimized')) {
                ModalDom.reOrder(modalId);
            } else {
                // Get the target
                const target = event.target;
                // Get the bounding rectangle of target
                const rect = target.getBoundingClientRect();
                // Mouse position
                const x = event.clientX - rect.left;
                const y = event.clientY - rect.top;
                let xSafe = 16;
                let ySafe = 16;

                if (xSafe > event.target.clientWidth - x && ySafe > event.target.clientHeight - y) {
                    event.stopPropagation();
                } else {
                    ModalDom.reOrder(modalId);
                }
            }
        });
    }

    static modalIdExists(modalId) {
        const modalViews = document.querySelectorAll([ '.p-modal', '.minimized' ]);
        const modal = Array.from(modalViews).find(modal => {
            if (modal.id === modalId) {
                ModalDom.preventReOrder = false;
                return true;
            }
        });
        return modal;
    }

    static reOrder(modalId, firstPosition) {
        const modalDrawer = document.querySelector('#modalDrawer');
        const modalViews = document.querySelectorAll([ '.p-modal', '.minimized' ]);
        const index = Array.from(modalViews).findIndex(modal => modal.id === modalId);
        const newTopModal = Array.from(modalViews).splice(index, 1)[0];

        if (newTopModal && modalDrawer.lastElementChild.id !== newTopModal.id) {
            modalDrawer.appendChild(newTopModal);
        } else if (firstPosition) {
            modalDrawer.prepend(newTopModal);
        }
    }

    static renderModalOrderHandler() {
        const modalDrawer = document.querySelector('#modalDrawer');
        const modalOrderHandler = document.querySelector('#modalOrderHandler');
        if (!modalOrderHandler) {
            const orderHandler = HtmlHelper.createElementFromHTML(`
           <div id="modalOrderHandler">
                <button title="Vorherige Seite" id="previousModalButton">
                    <i class="p-icon--chevron-up is-light" style="transform:rotate(90deg)"></i>
                </button>
                <button title="Nächstes Seite" id="nextModalButton">
                    <i class="p-icon--chevron-down is-light" style="transform:rotate(270deg)"></i>
                </button>
           </div> 
        `);

            modalDrawer.insertAdjacentHTML('afterend', orderHandler.outerHTML);
            const modalOrderHandler = document.querySelector('#modalOrderHandler');
            ModalDom.hideModalOrderHandler(modalDrawer, modalOrderHandler);

            modalOrderHandler.querySelector('#previousModalButton').addEventListener('click', () => {
                const modalDrawer = document.querySelector('#modalDrawer');
                const oldTopModalId = modalDrawer.firstChild.id;

                if (oldTopModalId) {
                    ModalDom.reOrder(oldTopModalId);
                    HtmlHelper.resetCssAnimation(modalDrawer.lastElementChild, 'modal-flash-once');
                }
            });
            modalOrderHandler.querySelector('#nextModalButton').addEventListener('click', () => {
                const modalDrawer = document.querySelector('#modalDrawer');
                const oldTopModal = modalDrawer.lastChild;
                const oldTopModalId = oldTopModal.id;
                oldTopModal.classList.remove('modal-flash-once');

                if (oldTopModalId) {
                    ModalDom.reOrder(oldTopModalId, true);
                    HtmlHelper.resetCssAnimation(modalDrawer.lastElementChild, 'modal-flash-once');
                }
            });
        } else {
            ModalDom.hideModalOrderHandler(modalDrawer, modalOrderHandler);
        }
    }

    static hideModalOrderHandler(modalDrawer, modalOrderHandler) {
        if (modalDrawer.childNodes.length <= 1) {
            modalOrderHandler.classList.add('d-none');
        } else {
            modalOrderHandler.classList.remove('d-none');
        }
    }

    static setModalAliasFilename(element) {
        if (!!element.files && element.files.length !== 0) {
            element.files.forEach(file => {
                if (file.hasOwnProperty('alias')) {
                    if ((file.alias === null || file.alias === '')
                        && (file.path !== null || file.path !== '')) {
                        const lastChar = file.path.lastIndexOf('/');
                        file.alias = file.path.substring(lastChar + 1);
                    }
                } else if (file.path !== null || file.path !== '') {
                    const lastChar = file.path.lastIndexOf('/');
                    file.alias = file.path.substring(lastChar + 1);
                }
            })
        }
    }

    static printPageArea(areaID) {

        const printContent = `
            ${document.getElementById(areaID).querySelector('.info-bar').innerHTML}
            ${document.getElementById(areaID).querySelector('#modal-description').innerHTML}
       `;
        const WinPrint = window.open('', 'test', 'width=900,height=650');

        for (let i = 0; i < document?.styleSheets?.length; i++) {
            const link = document.createElement('LINK');
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');
            link.setAttribute('href', document.styleSheets[i].href);
            link.setAttribute('id', 'printCss')
            WinPrint.document.body.classList.add('print')
            WinPrint.document.head.append(link);
        }
        const title = document.createElement('TITLE')
        title.innerHTML = window.location.href
        WinPrint.document.head.append(title)
        WinPrint.document.body.innerHTML = printContent.replace(/(\s*(class|id|style|type)="(?!page-break-after:always;).*?")*/g, '')

        const script = document.createElement('SCRIPT')
        script.innerHTML = "const i = setInterval(() => {if (!!document.getElementById('printCss').sheet) {clearInterval(i);window.print();window.close();}}, 500)";
        WinPrint.document.head.append(script)

    }

}
